import { s as da, f as ua, o as oo, c as io } from "./__searchspring__deps__index-_9zotoJQ.js";
import { P as ae, p as F, F as L, _ as H, x as K, a as z, q as Z, N as V, g as fa, A as Re, f as Vt, h as Yt, m as jn, b as Gt, $ as pa, j as ao, y as va } from "./__searchspring__deps__compat.module-ZWqUX18Z.js";
import { c as ot, b as ma, d as ie, P as ha, a as ga } from "./__searchspring__deps__TumiProduct-FLw0dcKI.js";
import { E as de, y as C, u as S, g as Ae, a as ba } from "./__searchspring__deps__main-kCZHrJ1L.js";
function W() {
  return W = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W.apply(this, arguments);
}
const lo = de(null), wa = ({ children: e, controller: t }) => C(lo.Provider, { value: t }, e), $a = () => ae(lo);
function ya(e) {
  return (t) => (
    // additional props must come after controller prop
    C(e, { controller: $a(), ...t })
  );
}
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const so = ot("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xn = ot("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xa = ot("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pa = ot("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pr = ot("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const co = ot("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function uo(e, t, n) {
  let [r, o] = F(e || t), i = L(e !== void 0), a = e !== void 0;
  H(() => {
    let c = i.current;
    c !== a && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}.`), i.current = a;
  }, [
    a
  ]);
  let l = a ? e : r, s = K((c, ...d) => {
    let h = (b, ...u) => {
      n && (Object.is(l, b) || n(b, ...u)), a || (l = b);
    };
    typeof c == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((u, ...g) => {
      let f = c(a ? l : u, ...g);
      return h(f, ...d), a ? u : f;
    })) : (a || o(c), h(c, ...d));
  }, [
    a,
    l,
    n
  ]);
  return [
    l,
    s
  ];
}
function Yn(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function dt(e, t, n, r) {
  t = Number(t), n = Number(n);
  let o = (e - (isNaN(t) ? 0 : t)) % r, i = Math.abs(o) * 2 >= r ? e + Math.sign(o) * (r - Math.abs(o)) : e - o;
  isNaN(t) ? !isNaN(n) && i > n && (i = Math.floor(n / r) * r) : i < t ? i = t : !isNaN(n) && i > n && (i = t + Math.floor((n - t) / r) * r);
  let a = r.toString(), l = a.indexOf("."), s = l >= 0 ? a.length - l : 0;
  if (s > 0) {
    let c = Math.pow(10, s);
    i = Math.round(i * c) / c;
  }
  return i;
}
const _t = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, fo = /* @__PURE__ */ z.createContext(_t), Ta = /* @__PURE__ */ z.createContext(!1);
let Sa = !!(typeof window < "u" && window.document && window.document.createElement), dn = /* @__PURE__ */ new WeakMap();
function Ea(e = !1) {
  let t = ae(fo), n = L(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let a = dn.get(i);
      a == null ? dn.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== a.state && (t.current = a.id, dn.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Ca(e) {
  let t = ae(fo);
  t === _t && !Sa && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Ea(!!e), r = `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Da(e) {
  let t = z.useId(), [n] = F(Gn()), r = n ? "react-aria" : `react-aria${_t.prefix}`;
  return e || `${r}-${t}`;
}
const Oa = typeof z.useId == "function" ? Da : Ca;
function Ma() {
  return !1;
}
function Ia() {
  return !0;
}
function Aa(e) {
  return () => {
  };
}
function Gn() {
  return typeof z.useSyncExternalStore == "function" ? z.useSyncExternalStore(Aa, Ma, Ia) : ae(Ta);
}
const it = typeof document < "u" ? z.useLayoutEffect : () => {
};
function ge(e) {
  const t = L(null);
  return it(() => {
    t.current = e;
  }, [
    e
  ]), K((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
let Na = !!(typeof window < "u" && window.document && window.document.createElement), Ht = /* @__PURE__ */ new Map();
function Pn(e) {
  let [t, n] = F(e), r = L(null), o = Oa(t), i = K((a) => {
    r.current = a;
  }, []);
  return Na && Ht.set(o, i), it(() => {
    let a = o;
    return () => {
      Ht.delete(a);
    };
  }, [
    o
  ]), H(() => {
    let a = r.current;
    a && (r.current = null, n(a));
  }), o;
}
function La(e, t) {
  if (e === t)
    return e;
  let n = Ht.get(e);
  if (n)
    return n(t), t;
  let r = Ht.get(t);
  return r ? (r(e), e) : t;
}
function po(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const be = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Pe = (e) => e && "window" in e && e.window === e ? e : be(e).defaultView || window;
function oe(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let i = t[o], a = r[o];
      typeof i == "function" && typeof a == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = po(i, a) : (o === "className" || o === "UNSAFE_className") && typeof i == "string" && typeof a == "string" ? t[o] = ma(i, a) : o === "id" && i && a ? t.id = La(i, a) : t[o] = a !== void 0 ? a : i;
    }
  }
  return t;
}
function ka(...e) {
  return e.length === 1 ? e[0] : (t) => {
    for (let n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
const Ra = /* @__PURE__ */ new Set([
  "id"
]), Fa = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Va = /* @__PURE__ */ new Set([
  "href",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), _a = /^(data-.*)$/;
function qt(e, t = {}) {
  let { labelable: n, isLink: r, propNames: o } = t, i = {};
  for (const a in e)
    Object.prototype.hasOwnProperty.call(e, a) && (Ra.has(a) || n && Fa.has(a) || r && Va.has(a) || o != null && o.has(a) || _a.test(a)) && (i[a] = e[a]);
  return i;
}
function ke(e) {
  if (Ha())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = Ba(e);
    e.focus(), Ka(t);
  }
}
let Tt = null;
function Ha() {
  if (Tt == null) {
    Tt = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Tt = !0, !0;
        }
      });
    } catch {
    }
  }
  return Tt;
}
function Ba(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Ka(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function Zt(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function qn(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function mt() {
  return qn(/^Mac/i);
}
function Wa() {
  return qn(/^iPhone/i);
}
function vo() {
  return qn(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  mt() && navigator.maxTouchPoints > 1;
}
function mo() {
  return Wa() || vo();
}
function za() {
  return Zt(/AppleWebKit/i) && !Ua();
}
function Ua() {
  return Zt(/Chrome/i);
}
function ho() {
  return Zt(/Android/i);
}
function ja() {
  return Zt(/Firefox/i);
}
function ht(e, t, n = !0) {
  var r, o;
  let { metaKey: i, ctrlKey: a, altKey: l, shiftKey: s } = t;
  ja() && (!((o = window.event) === null || o === void 0 || (r = o.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (mt() ? i = !0 : a = !0);
  let c = za() && mt() && !vo() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: a,
    altKey: l,
    shiftKey: s
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: a,
    altKey: l,
    shiftKey: s,
    bubbles: !0,
    cancelable: !0
  });
  ht.isOpening = n, ke(e), e.dispatchEvent(c), ht.isOpening = !1;
}
ht.isOpening = !1;
let qe = /* @__PURE__ */ new Map(), Tn = /* @__PURE__ */ new Set();
function vr() {
  if (typeof window > "u")
    return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target)
      return;
    let o = qe.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), qe.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target)
      return;
    let o = qe.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), qe.delete(r.target)), qe.size === 0)) {
      for (let i of Tn)
        i();
      Tn.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? vr() : document.addEventListener("DOMContentLoaded", vr));
function go(e) {
  requestAnimationFrame(() => {
    qe.size === 0 ? e() : Tn.add(e);
  });
}
function Qt() {
  let e = L(/* @__PURE__ */ new Map()), t = K((o, i, a, l) => {
    let s = l != null && l.once ? (...c) => {
      e.current.delete(a), a(...c);
    } : a;
    e.current.set(a, {
      type: i,
      eventTarget: o,
      fn: s,
      options: l
    }), o.addEventListener(i, a, l);
  }, []), n = K((o, i, a, l) => {
    var s;
    let c = ((s = e.current.get(a)) === null || s === void 0 ? void 0 : s.fn) || a;
    o.removeEventListener(i, c, l), e.current.delete(a);
  }, []), r = K(() => {
    e.current.forEach((o, i) => {
      n(o.eventTarget, o.type, i, o.options);
    });
  }, [
    n
  ]);
  return H(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Xa(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = Pn(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      n,
      ...o.trim().split(/\s+/)
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
function Ya(e) {
  const t = L(null);
  return Z(() => ({
    get current() {
      return t.current;
    },
    set current(n) {
      t.current = n, typeof e == "function" ? e(n) : e && (e.current = n);
    }
  }), [
    e
  ]);
}
function bo(e, t) {
  it(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Sn(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ho() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Ga(e) {
  return !ho() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function wo(e, t, n) {
  let r = L(t), o = ge(() => {
    n && n(r.current);
  });
  H(() => {
    var i;
    let a = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return a == null || a.addEventListener("reset", o), () => {
      a == null || a.removeEventListener("reset", o);
    };
  }, [
    e,
    o
  ]);
}
function qa(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function $o(e, t, n) {
  if (!t.has(e))
    throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function Za(e, t) {
  var n = $o(e, t, "get");
  return qa(e, n);
}
function Qa(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Ja(e, t, n) {
  Qa(e, t), t.set(e, n);
}
function el(e, t, n) {
  if (t.set)
    t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function mr(e, t, n) {
  var r = $o(e, t, "set");
  return el(e, r, n), n;
}
let Qe = "default", En = "", Lt = /* @__PURE__ */ new WeakMap();
function Cn(e) {
  if (mo()) {
    if (Qe === "default") {
      const t = be(e);
      En = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Qe = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (Lt.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function ut(e) {
  if (mo()) {
    if (Qe !== "disabled")
      return;
    Qe = "restoring", setTimeout(() => {
      go(() => {
        if (Qe === "restoring") {
          const t = be(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = En || ""), En = "", Qe = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Lt.has(e)) {
    let t = Lt.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Lt.delete(e);
  }
}
const yo = z.createContext({
  register: () => {
  }
});
yo.displayName = "PressResponderContext";
function tl(e) {
  let t = ae(yo);
  if (t) {
    let { register: n, ...r } = t;
    e = oe(r, e), n();
  }
  return bo(t, e.ref), e;
}
var St = /* @__PURE__ */ new WeakMap();
class Et {
  continuePropagation() {
    mr(this, St, !1);
  }
  get shouldStopPropagation() {
    return Za(this, St);
  }
  constructor(t, n, r) {
    Ja(this, St, {
      writable: !0,
      value: void 0
    }), mr(this, St, !0), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey;
  }
}
const hr = Symbol("linkClicked");
function gr(e) {
  let {
    onPress: t,
    onPressChange: n,
    onPressStart: r,
    onPressEnd: o,
    onPressUp: i,
    isDisabled: a,
    isPressed: l,
    preventFocusOnPress: s,
    shouldCancelOnPointerExit: c,
    allowTextSelectionOnPress: d,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: h,
    ...b
  } = tl(e), [u, g] = F(!1), f = L({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: w, removeAllGlobalListeners: m } = Qt(), v = ge((p, I) => {
    let R = f.current;
    if (a || R.didFirePressStart)
      return !1;
    let E = !0;
    if (R.isTriggeringEvent = !0, r) {
      let k = new Et("pressstart", I, p);
      r(k), E = k.shouldStopPropagation;
    }
    return n && n(!0), R.isTriggeringEvent = !1, R.didFirePressStart = !0, g(!0), E;
  }), $ = ge((p, I, R = !0) => {
    let E = f.current;
    if (!E.didFirePressStart)
      return !1;
    E.ignoreClickAfterPress = !0, E.didFirePressStart = !1, E.isTriggeringEvent = !0;
    let k = !0;
    if (o) {
      let x = new Et("pressend", I, p);
      o(x), k = x.shouldStopPropagation;
    }
    if (n && n(!1), g(!1), t && R && !a) {
      let x = new Et("press", I, p);
      t(x), k && (k = x.shouldStopPropagation);
    }
    return E.isTriggeringEvent = !1, k;
  }), y = ge((p, I) => {
    let R = f.current;
    if (a)
      return !1;
    if (i) {
      R.isTriggeringEvent = !0;
      let E = new Et("pressup", I, p);
      return i(E), R.isTriggeringEvent = !1, E.shouldStopPropagation;
    }
    return !0;
  }), T = ge((p) => {
    let I = f.current;
    I.isPressed && I.target && (I.isOverTarget && I.pointerType != null && $(Ee(I.target, p), I.pointerType, !1), I.isPressed = !1, I.isOverTarget = !1, I.activePointerId = null, I.pointerType = null, m(), d || ut(I.target));
  }), O = ge((p) => {
    c && T(p);
  }), A = Z(() => {
    let p = f.current, I = {
      onKeyDown(E) {
        if (un(E.nativeEvent, E.currentTarget) && E.currentTarget.contains(E.target)) {
          var k;
          wr(E.target, E.key) && E.preventDefault();
          let x = !0;
          if (!p.isPressed && !E.repeat) {
            p.target = E.currentTarget, p.isPressed = !0, x = v(E, "keyboard");
            let P = E.currentTarget, N = (M) => {
              un(M, P) && !M.repeat && P.contains(M.target) && p.target && y(Ee(p.target, M), "keyboard");
            };
            w(be(E.currentTarget), "keyup", po(N, R), !0);
          }
          x && E.stopPropagation(), E.metaKey && mt() && ((k = p.metaKeyEvents) === null || k === void 0 || k.set(E.key, E.nativeEvent));
        } else
          E.key === "Meta" && (p.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(E) {
        if (!(E && !E.currentTarget.contains(E.target)) && E && E.button === 0 && !p.isTriggeringEvent && !ht.isOpening) {
          let k = !0;
          if (a && E.preventDefault(), !p.ignoreClickAfterPress && !p.ignoreEmulatedMouseEvents && !p.isPressed && (p.pointerType === "virtual" || Sn(E.nativeEvent))) {
            !a && !s && ke(E.currentTarget);
            let x = v(E, "virtual"), P = y(E, "virtual"), N = $(E, "virtual");
            k = x && P && N;
          }
          p.ignoreEmulatedMouseEvents = !1, p.ignoreClickAfterPress = !1, k && E.stopPropagation();
        }
      }
    }, R = (E) => {
      var k;
      if (p.isPressed && p.target && un(E, p.target)) {
        var x;
        wr(E.target, E.key) && E.preventDefault();
        let N = E.target;
        $(Ee(p.target, E), "keyboard", p.target.contains(N)), m(), E.key !== "Enter" && Zn(p.target) && p.target.contains(N) && !E[hr] && (E[hr] = !0, ht(p.target, E, !1)), p.isPressed = !1, (x = p.metaKeyEvents) === null || x === void 0 || x.delete(E.key);
      } else if (E.key === "Meta" && (!((k = p.metaKeyEvents) === null || k === void 0) && k.size)) {
        var P;
        let N = p.metaKeyEvents;
        p.metaKeyEvents = void 0;
        for (let M of N.values())
          (P = p.target) === null || P === void 0 || P.dispatchEvent(new KeyboardEvent("keyup", M));
      }
    };
    if (typeof PointerEvent < "u") {
      I.onPointerDown = (P) => {
        if (P.button !== 0 || !P.currentTarget.contains(P.target))
          return;
        if (Ga(P.nativeEvent)) {
          p.pointerType = "virtual";
          return;
        }
        fn(P.currentTarget) && P.preventDefault(), p.pointerType = P.pointerType;
        let N = !0;
        p.isPressed || (p.isPressed = !0, p.isOverTarget = !0, p.activePointerId = P.pointerId, p.target = P.currentTarget, !a && !s && ke(P.currentTarget), d || Cn(p.target), N = v(P, p.pointerType), w(be(P.currentTarget), "pointermove", E, !1), w(be(P.currentTarget), "pointerup", k, !1), w(be(P.currentTarget), "pointercancel", x, !1)), N && P.stopPropagation();
      }, I.onMouseDown = (P) => {
        P.currentTarget.contains(P.target) && P.button === 0 && (fn(P.currentTarget) && P.preventDefault(), P.stopPropagation());
      }, I.onPointerUp = (P) => {
        !P.currentTarget.contains(P.target) || p.pointerType === "virtual" || P.button === 0 && je(P, P.currentTarget) && y(P, p.pointerType || P.pointerType);
      };
      let E = (P) => {
        P.pointerId === p.activePointerId && (p.target && je(P, p.target) ? !p.isOverTarget && p.pointerType != null && (p.isOverTarget = !0, v(Ee(p.target, P), p.pointerType)) : p.target && p.isOverTarget && p.pointerType != null && (p.isOverTarget = !1, $(Ee(p.target, P), p.pointerType, !1), O(P)));
      }, k = (P) => {
        P.pointerId === p.activePointerId && p.isPressed && P.button === 0 && p.target && (je(P, p.target) && p.pointerType != null ? $(Ee(p.target, P), p.pointerType) : p.isOverTarget && p.pointerType != null && $(Ee(p.target, P), p.pointerType, !1), p.isPressed = !1, p.isOverTarget = !1, p.activePointerId = null, p.pointerType = null, m(), d || ut(p.target));
      }, x = (P) => {
        T(P);
      };
      I.onDragStart = (P) => {
        P.currentTarget.contains(P.target) && T(P);
      };
    } else {
      I.onMouseDown = (x) => {
        if (x.button !== 0 || !x.currentTarget.contains(x.target))
          return;
        if (fn(x.currentTarget) && x.preventDefault(), p.ignoreEmulatedMouseEvents) {
          x.stopPropagation();
          return;
        }
        p.isPressed = !0, p.isOverTarget = !0, p.target = x.currentTarget, p.pointerType = Sn(x.nativeEvent) ? "virtual" : "mouse", !a && !s && ke(x.currentTarget), v(x, p.pointerType) && x.stopPropagation(), w(be(x.currentTarget), "mouseup", E, !1);
      }, I.onMouseEnter = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = !0;
        p.isPressed && !p.ignoreEmulatedMouseEvents && p.pointerType != null && (p.isOverTarget = !0, P = v(x, p.pointerType)), P && x.stopPropagation();
      }, I.onMouseLeave = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = !0;
        p.isPressed && !p.ignoreEmulatedMouseEvents && p.pointerType != null && (p.isOverTarget = !1, P = $(x, p.pointerType, !1), O(x)), P && x.stopPropagation();
      }, I.onMouseUp = (x) => {
        x.currentTarget.contains(x.target) && !p.ignoreEmulatedMouseEvents && x.button === 0 && y(x, p.pointerType || "mouse");
      };
      let E = (x) => {
        if (x.button === 0) {
          if (p.isPressed = !1, m(), p.ignoreEmulatedMouseEvents) {
            p.ignoreEmulatedMouseEvents = !1;
            return;
          }
          p.target && je(x, p.target) && p.pointerType != null ? $(Ee(p.target, x), p.pointerType) : p.target && p.isOverTarget && p.pointerType != null && $(Ee(p.target, x), p.pointerType, !1), p.isOverTarget = !1;
        }
      };
      I.onTouchStart = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = nl(x.nativeEvent);
        if (!P)
          return;
        p.activePointerId = P.identifier, p.ignoreEmulatedMouseEvents = !0, p.isOverTarget = !0, p.isPressed = !0, p.target = x.currentTarget, p.pointerType = "touch", !a && !s && ke(x.currentTarget), d || Cn(p.target), v(x, p.pointerType) && x.stopPropagation(), w(Pe(x.currentTarget), "scroll", k, !0);
      }, I.onTouchMove = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        if (!p.isPressed) {
          x.stopPropagation();
          return;
        }
        let P = br(x.nativeEvent, p.activePointerId), N = !0;
        P && je(P, x.currentTarget) ? !p.isOverTarget && p.pointerType != null && (p.isOverTarget = !0, N = v(x, p.pointerType)) : p.isOverTarget && p.pointerType != null && (p.isOverTarget = !1, N = $(x, p.pointerType, !1), O(x)), N && x.stopPropagation();
      }, I.onTouchEnd = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        if (!p.isPressed) {
          x.stopPropagation();
          return;
        }
        let P = br(x.nativeEvent, p.activePointerId), N = !0;
        P && je(P, x.currentTarget) && p.pointerType != null ? (y(x, p.pointerType), N = $(x, p.pointerType)) : p.isOverTarget && p.pointerType != null && (N = $(x, p.pointerType, !1)), N && x.stopPropagation(), p.isPressed = !1, p.activePointerId = null, p.isOverTarget = !1, p.ignoreEmulatedMouseEvents = !0, p.target && !d && ut(p.target), m();
      }, I.onTouchCancel = (x) => {
        x.currentTarget.contains(x.target) && (x.stopPropagation(), p.isPressed && T(x));
      };
      let k = (x) => {
        p.isPressed && x.target.contains(p.target) && T({
          currentTarget: p.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      I.onDragStart = (x) => {
        x.currentTarget.contains(x.target) && T(x);
      };
    }
    return I;
  }, [
    w,
    a,
    s,
    m,
    d,
    T,
    O,
    $,
    v,
    y
  ]);
  return H(() => () => {
    var p;
    d || ut((p = f.current.target) !== null && p !== void 0 ? p : void 0);
  }, [
    d
  ]), {
    isPressed: l || u,
    pressProps: oe(b, A)
  };
}
function Zn(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function un(e, t) {
  const { key: n, code: r } = e, o = t, i = o.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(o instanceof Pe(o).HTMLInputElement && !xo(o, n) || o instanceof Pe(o).HTMLTextAreaElement || o.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && Zn(o)) && n !== "Enter");
}
function nl(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function br(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const o = n[r];
    if (o.identifier === t)
      return o;
  }
  return null;
}
function Ee(e, t) {
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey
  };
}
function rl(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function ol(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function je(e, t) {
  let n = t.getBoundingClientRect(), r = rl(e);
  return ol(n, r);
}
function fn(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function wr(e, t) {
  return e instanceof HTMLInputElement ? !xo(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Zn(e);
}
const il = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function xo(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : il.has(e.type);
}
class al {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function Po(e) {
  let t = L({
    isFocused: !1,
    observer: null
  });
  it(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = ge((r) => {
    e == null || e(r);
  });
  return K((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, i = (a) => {
        t.current.isFocused = !1, o.disabled && n(new al("blur", a)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let l = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function To(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const i = K((s) => {
    if (s.target === s.currentTarget)
      return r && r(s), o && o(!1), !0;
  }, [
    r,
    o
  ]), a = Po(i), l = K((s) => {
    s.target === s.currentTarget && document.activeElement === s.target && (n && n(s), o && o(!0), a(s));
  }, [
    o,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? l : void 0,
      onBlur: !t && (r || o) ? i : void 0
    }
  };
}
let Ke = null, Dn = /* @__PURE__ */ new Set(), pt = /* @__PURE__ */ new Map(), He = !1, On = !1;
const ll = {
  Tab: !0,
  Escape: !0
};
function Jt(e, t) {
  for (let n of Dn)
    n(e, t);
}
function sl(e) {
  return !(e.metaKey || !mt() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Bt(e) {
  He = !0, sl(e) && (Ke = "keyboard", Jt("keyboard", e));
}
function he(e) {
  Ke = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (He = !0, Jt("pointer", e));
}
function So(e) {
  Sn(e) && (He = !0, Ke = "virtual");
}
function Eo(e) {
  e.target === window || e.target === document || (!He && !On && (Ke = "virtual", Jt("virtual", e)), He = !1, On = !1);
}
function Co() {
  He = !1, On = !0;
}
function Mn(e) {
  if (typeof window > "u" || pt.get(Pe(e)))
    return;
  const t = Pe(e), n = be(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    He = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Bt, !0), n.addEventListener("keyup", Bt, !0), n.addEventListener("click", So, !0), t.addEventListener("focus", Eo, !0), t.addEventListener("blur", Co, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", he, !0), n.addEventListener("pointermove", he, !0), n.addEventListener("pointerup", he, !0)) : (n.addEventListener("mousedown", he, !0), n.addEventListener("mousemove", he, !0), n.addEventListener("mouseup", he, !0)), t.addEventListener("beforeunload", () => {
    Do(e);
  }, {
    once: !0
  }), pt.set(t, {
    focus: r
  });
}
const Do = (e, t) => {
  const n = Pe(e), r = be(e);
  t && r.removeEventListener("DOMContentLoaded", t), pt.has(n) && (n.HTMLElement.prototype.focus = pt.get(n).focus, r.removeEventListener("keydown", Bt, !0), r.removeEventListener("keyup", Bt, !0), r.removeEventListener("click", So, !0), n.removeEventListener("focus", Eo, !0), n.removeEventListener("blur", Co, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", he, !0), r.removeEventListener("pointermove", he, !0), r.removeEventListener("pointerup", he, !0)) : (r.removeEventListener("mousedown", he, !0), r.removeEventListener("mousemove", he, !0), r.removeEventListener("mouseup", he, !0)), pt.delete(n));
};
function cl(e) {
  const t = be(e);
  let n;
  return t.readyState !== "loading" ? Mn(e) : (n = () => {
    Mn(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Do(e, n);
}
typeof document < "u" && cl();
function Oo() {
  return Ke !== "pointer";
}
function dl() {
  return Ke;
}
function Mo(e) {
  Ke = e, Jt(e, null);
}
const ul = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function fl(e, t, n) {
  var r;
  const o = typeof window < "u" ? Pe(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? Pe(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, a = typeof window < "u" ? Pe(n == null ? void 0 : n.target).HTMLElement : HTMLElement, l = typeof window < "u" ? Pe(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || (n == null ? void 0 : n.target) instanceof o && !ul.has(n == null || (r = n.target) === null || r === void 0 ? void 0 : r.type) || (n == null ? void 0 : n.target) instanceof i || (n == null ? void 0 : n.target) instanceof a && (n == null ? void 0 : n.target.isContentEditable), !(e && t === "keyboard" && n instanceof l && !ll[n.key]);
}
function pl(e, t, n) {
  Mn(), H(() => {
    let r = (o, i) => {
      fl(!!(n != null && n.isTextInput), o, i) && e(Oo());
    };
    return Dn.add(r), () => {
      Dn.delete(r);
    };
  }, t);
}
function Io(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, i = L({
    isFocusWithin: !1
  }), a = K((c) => {
    i.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (i.current.isFocusWithin = !1, n && n(c), o && o(!1));
  }, [
    n,
    o,
    i
  ]), l = Po(a), s = K((c) => {
    !i.current.isFocusWithin && document.activeElement === c.target && (r && r(c), o && o(!0), i.current.isFocusWithin = !0, l(c));
  }, [
    r,
    o,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: s,
      onBlur: a
    }
  };
}
let Kt = !1, pn = 0;
function In() {
  Kt = !0, setTimeout(() => {
    Kt = !1;
  }, 50);
}
function $r(e) {
  e.pointerType === "touch" && In();
}
function vl() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", $r) : document.addEventListener("touchend", In), pn++, () => {
      pn--, !(pn > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", $r) : document.removeEventListener("touchend", In));
    };
}
function Qn(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [i, a] = F(!1), l = L({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  H(vl, []);
  let { hoverProps: s, triggerHoverEnd: c } = Z(() => {
    let d = (u, g) => {
      if (l.pointerType = g, o || g === "touch" || l.isHovered || !u.currentTarget.contains(u.target))
        return;
      l.isHovered = !0;
      let f = u.currentTarget;
      l.target = f, t && t({
        type: "hoverstart",
        target: f,
        pointerType: g
      }), n && n(!0), a(!0);
    }, h = (u, g) => {
      if (l.pointerType = "", l.target = null, g === "touch" || !l.isHovered)
        return;
      l.isHovered = !1;
      let f = u.currentTarget;
      r && r({
        type: "hoverend",
        target: f,
        pointerType: g
      }), n && n(!1), a(!1);
    }, b = {};
    return typeof PointerEvent < "u" ? (b.onPointerEnter = (u) => {
      Kt && u.pointerType === "mouse" || d(u, u.pointerType);
    }, b.onPointerLeave = (u) => {
      !o && u.currentTarget.contains(u.target) && h(u, u.pointerType);
    }) : (b.onTouchStart = () => {
      l.ignoreEmulatedMouseEvents = !0;
    }, b.onMouseEnter = (u) => {
      !l.ignoreEmulatedMouseEvents && !Kt && d(u, "mouse"), l.ignoreEmulatedMouseEvents = !1;
    }, b.onMouseLeave = (u) => {
      !o && u.currentTarget.contains(u.target) && h(u, "mouse");
    }), {
      hoverProps: b,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    o,
    l
  ]);
  return H(() => {
    o && c({
      currentTarget: l.target
    }, l.pointerType);
  }, [
    o
  ]), {
    hoverProps: s,
    isHovered: i
  };
}
function yr(e) {
  if (!e)
    return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Ao(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: yr(e.onKeyDown),
      onKeyUp: yr(e.onKeyUp)
    }
  };
}
function No(e) {
  let { onMoveStart: t, onMove: n, onMoveEnd: r } = e, o = L({
    didMove: !1,
    lastPosition: null,
    id: null
  }), { addGlobalListener: i, removeGlobalListener: a } = Qt(), l = ge((d, h, b, u) => {
    b === 0 && u === 0 || (o.current.didMove || (o.current.didMove = !0, t == null || t({
      type: "movestart",
      pointerType: h,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    })), n == null || n({
      type: "move",
      pointerType: h,
      deltaX: b,
      deltaY: u,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    }));
  }), s = ge((d, h) => {
    ut(), o.current.didMove && (r == null || r({
      type: "moveend",
      pointerType: h,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey
    }));
  });
  return {
    moveProps: Z(() => {
      let d = {}, h = () => {
        Cn(), o.current.didMove = !1;
      };
      if (typeof PointerEvent > "u") {
        let u = (m) => {
          if (m.button === 0) {
            var v, $, y, T;
            l(m, "mouse", m.pageX - ((y = (v = o.current.lastPosition) === null || v === void 0 ? void 0 : v.pageX) !== null && y !== void 0 ? y : 0), m.pageY - ((T = ($ = o.current.lastPosition) === null || $ === void 0 ? void 0 : $.pageY) !== null && T !== void 0 ? T : 0)), o.current.lastPosition = {
              pageX: m.pageX,
              pageY: m.pageY
            };
          }
        }, g = (m) => {
          m.button === 0 && (s(m, "mouse"), a(window, "mousemove", u, !1), a(window, "mouseup", g, !1));
        };
        d.onMouseDown = (m) => {
          m.button === 0 && (h(), m.stopPropagation(), m.preventDefault(), o.current.lastPosition = {
            pageX: m.pageX,
            pageY: m.pageY
          }, i(window, "mousemove", u, !1), i(window, "mouseup", g, !1));
        };
        let f = (m) => {
          let v = [
            ...m.changedTouches
          ].findIndex(({ identifier: A }) => A === o.current.id);
          if (v >= 0) {
            var $, y;
            let { pageX: A, pageY: p } = m.changedTouches[v];
            var T, O;
            l(m, "touch", A - ((T = ($ = o.current.lastPosition) === null || $ === void 0 ? void 0 : $.pageX) !== null && T !== void 0 ? T : 0), p - ((O = (y = o.current.lastPosition) === null || y === void 0 ? void 0 : y.pageY) !== null && O !== void 0 ? O : 0)), o.current.lastPosition = {
              pageX: A,
              pageY: p
            };
          }
        }, w = (m) => {
          [
            ...m.changedTouches
          ].findIndex(({ identifier: $ }) => $ === o.current.id) >= 0 && (s(m, "touch"), o.current.id = null, a(window, "touchmove", f), a(window, "touchend", w), a(window, "touchcancel", w));
        };
        d.onTouchStart = (m) => {
          if (m.changedTouches.length === 0 || o.current.id != null)
            return;
          let { pageX: v, pageY: $, identifier: y } = m.changedTouches[0];
          h(), m.stopPropagation(), m.preventDefault(), o.current.lastPosition = {
            pageX: v,
            pageY: $
          }, o.current.id = y, i(window, "touchmove", f, !1), i(window, "touchend", w, !1), i(window, "touchcancel", w, !1);
        };
      } else {
        let u = (f) => {
          if (f.pointerId === o.current.id) {
            var w, m;
            let y = f.pointerType || "mouse";
            var v, $;
            l(f, y, f.pageX - ((v = (w = o.current.lastPosition) === null || w === void 0 ? void 0 : w.pageX) !== null && v !== void 0 ? v : 0), f.pageY - (($ = (m = o.current.lastPosition) === null || m === void 0 ? void 0 : m.pageY) !== null && $ !== void 0 ? $ : 0)), o.current.lastPosition = {
              pageX: f.pageX,
              pageY: f.pageY
            };
          }
        }, g = (f) => {
          if (f.pointerId === o.current.id) {
            let w = f.pointerType || "mouse";
            s(f, w), o.current.id = null, a(window, "pointermove", u, !1), a(window, "pointerup", g, !1), a(window, "pointercancel", g, !1);
          }
        };
        d.onPointerDown = (f) => {
          f.button === 0 && o.current.id == null && (h(), f.stopPropagation(), f.preventDefault(), o.current.lastPosition = {
            pageX: f.pageX,
            pageY: f.pageY
          }, o.current.id = f.pointerId, i(window, "pointermove", u, !1), i(window, "pointerup", g, !1), i(window, "pointercancel", g, !1));
        };
      }
      let b = (u, g, f) => {
        h(), l(u, "keyboard", g, f), s(u, "keyboard");
      };
      return d.onKeyDown = (u) => {
        switch (u.key) {
          case "Left":
          case "ArrowLeft":
            u.preventDefault(), u.stopPropagation(), b(u, -1, 0);
            break;
          case "Right":
          case "ArrowRight":
            u.preventDefault(), u.stopPropagation(), b(u, 1, 0);
            break;
          case "Up":
          case "ArrowUp":
            u.preventDefault(), u.stopPropagation(), b(u, 0, -1);
            break;
          case "Down":
          case "ArrowDown":
            u.preventDefault(), u.stopPropagation(), b(u, 0, 1);
            break;
        }
      }, d;
    }, [
      o,
      i,
      a,
      l,
      s
    ])
  };
}
function ml(e) {
  const t = be(e);
  if (dl() === "virtual") {
    let n = t.activeElement;
    go(() => {
      t.activeElement === n && e.isConnected && ke(e);
    });
  } else
    ke(e);
}
function hl(e, t) {
  return !e || !t ? !1 : t.some((n) => n.contains(e));
}
class Jn {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let o = this.fastMap.get(n ?? null);
    if (!o)
      return;
    let i = new xr({
      scopeRef: t
    });
    o.addChild(i), i.parent = o, this.fastMap.set(t, i), r && (i.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null)
      return;
    let n = this.fastMap.get(t);
    if (!n)
      return;
    let r = n.parent;
    for (let i of this.traverse())
      i !== n && n.nodeToRestore && i.nodeToRestore && n.scopeRef && n.scopeRef.current && hl(i.nodeToRestore, n.scopeRef.current) && (i.nodeToRestore = n.nodeToRestore);
    let o = n.children;
    r && (r.removeChild(n), o.size > 0 && o.forEach((i) => r && r.addChild(i))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0)
      for (let n of t.children)
        yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new Jn();
    var r;
    for (let o of this.traverse())
      n.addTreeNode(o.scopeRef, (r = (t = o.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, o.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new xr({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class xr {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
new Jn();
function Lo(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = L({
    isFocused: !1,
    isFocusVisible: t || Oo()
  }), [i, a] = F(!1), [l, s] = F(() => o.current.isFocused && o.current.isFocusVisible), c = K(() => s(o.current.isFocused && o.current.isFocusVisible), []), d = K((u) => {
    o.current.isFocused = u, a(u), c();
  }, [
    c
  ]);
  pl((u) => {
    o.current.isFocusVisible = u, c();
  }, [], {
    isTextInput: n
  });
  let { focusProps: h } = To({
    isDisabled: r,
    onFocusChange: d
  }), { focusWithinProps: b } = Io({
    isDisabled: !r,
    onFocusWithinChange: d
  });
  return {
    isFocused: i,
    isFocusVisible: l,
    focusProps: r ? b : h
  };
}
let gl = /* @__PURE__ */ z.createContext(null);
function bl(e) {
  let t = ae(gl) || {};
  bo(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function ko(e, t) {
  let { focusProps: n } = To(e), { keyboardProps: r } = Ao(e), o = oe(n, r), i = bl(t), a = e.isDisabled ? {} : i, l = L(e.autoFocus);
  return H(() => {
    l.current && t.current && ml(t.current), l.current = !1;
  }, [
    t
  ]), {
    focusableProps: oe({
      ...o,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, a)
  };
}
let vn = /* @__PURE__ */ new Map(), An = !1;
try {
  An = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Wt = !1;
try {
  Wt = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Ro = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class wl {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!An && this.options.signDisplay != null ? n = yl(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Wt) {
      var r;
      let { unit: o, unitDisplay: i = "short", locale: a } = this.resolvedOptions();
      if (!o)
        return n;
      let l = (r = Ro[o]) === null || r === void 0 ? void 0 : r[i];
      n += l[a] || l.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(t, n);
    if (n < t)
      throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t)
      throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), o = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !An && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Wt && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = $l(t, n), this.options = n;
  }
}
function $l(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Wt) {
    var r;
    let { unit: a, unitDisplay: l = "short" } = t;
    if (!a)
      throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = Ro[a]) === null || r === void 0) && r[l]))
      throw new Error(`Unsupported unit ${a} with unitDisplay = ${l}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let o = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (vn.has(o))
    return vn.get(o);
  let i = new Intl.NumberFormat(e, t);
  return vn.set(o, i), i;
}
function yl(e, t, n) {
  if (t === "auto")
    return e.format(n);
  if (t === "never")
    return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let o = e.format(-n), i = e.format(n), a = o.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...a
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(i, "!!!").replace(a, "+").replace("!!!", i);
    } else
      return e.format(n);
  }
}
const xl = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Pl = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Tl(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r)
      return r.direction === "rtl";
    if (n.script)
      return xl.has(n.script);
  }
  let t = e.split("-")[0];
  return Pl.has(t);
}
const Sl = Symbol.for("react-aria.i18n.locale");
function Fo() {
  let e = typeof window < "u" && window[Sl] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Tl(e) ? "rtl" : "ltr"
  };
}
let Nn = Fo(), ft = /* @__PURE__ */ new Set();
function Pr() {
  Nn = Fo();
  for (let e of ft)
    e(Nn);
}
function El() {
  let e = Gn(), [t, n] = F(Nn);
  return H(() => (ft.size === 0 && window.addEventListener("languagechange", Pr), ft.add(n), () => {
    ft.delete(n), ft.size === 0 && window.removeEventListener("languagechange", Pr);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Cl = /* @__PURE__ */ z.createContext(null);
function er() {
  let e = El();
  return ae(Cl) || e;
}
function Dl(e = {}) {
  let { locale: t } = er();
  return Z(() => new wl(t, e), [
    t,
    e
  ]);
}
var xe = function() {
  return xe = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, xe.apply(this, arguments);
};
function Vo(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Ol(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Ml(e, t, n) {
  let { validationBehavior: r, focus: o } = e;
  it(() => {
    if (r === "native" && (n != null && n.current)) {
      let s = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(s), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Al(n.current));
    }
  });
  let i = ge(() => {
    t.resetValidation();
  }), a = ge((s) => {
    var c;
    t.displayValidation.isInvalid || t.commitValidation();
    let d = n == null || (c = n.current) === null || c === void 0 ? void 0 : c.form;
    if (!s.defaultPrevented && n && d && Nl(d) === n.current) {
      var h;
      o ? o() : (h = n.current) === null || h === void 0 || h.focus(), Mo("keyboard");
    }
    s.preventDefault();
  }), l = ge(() => {
    t.commitValidation();
  });
  H(() => {
    let s = n == null ? void 0 : n.current;
    if (!s)
      return;
    let c = s.form;
    return s.addEventListener("invalid", a), s.addEventListener("change", l), c == null || c.addEventListener("reset", i), () => {
      s.removeEventListener("invalid", a), s.removeEventListener("change", l), c == null || c.removeEventListener("reset", i);
    };
  }, [
    n,
    a,
    l,
    i,
    r
  ]);
}
function Il(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Al(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: Il(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function Nl(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (!n.validity.valid)
      return n;
  }
  return null;
}
const _o = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Ho = {
  ..._o,
  customError: !0,
  valid: !1
}, Ze = {
  isInvalid: !1,
  validationDetails: _o,
  validationErrors: []
}, Ll = de({}), Ln = "__formValidationState" + Date.now();
function Bo(e) {
  if (e[Ln]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: o, commitValidation: i } = e[Ln];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: o,
      commitValidation: i
    };
  }
  return kl(e);
}
function kl(e) {
  let { isInvalid: t, validationState: n, name: r, value: o, builtinValidation: i, validate: a, validationBehavior: l = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let s = t ? {
    isInvalid: !0,
    validationErrors: [],
    validationDetails: Ho
  } : null, c = Z(() => Tr(Rl(a, o)), [
    a,
    o
  ]);
  i != null && i.validationDetails.valid && (i = null);
  let d = ae(Ll), h = Z(() => r ? Array.isArray(r) ? r.flatMap((R) => kn(d[R])) : kn(d[r]) : [], [
    d,
    r
  ]), [b, u] = F(d), [g, f] = F(!1);
  d !== b && (u(d), f(!1));
  let w = Z(() => Tr(g ? [] : h), [
    g,
    h
  ]), m = L(Ze), [v, $] = F(Ze), y = L(Ze), T = () => {
    if (!O)
      return;
    A(!1);
    let R = c || i || m.current;
    mn(R, y.current) || (y.current = R, $(R));
  }, [O, A] = F(!1);
  return H(T), {
    realtimeValidation: s || w || c || i || Ze,
    displayValidation: l === "native" ? s || w || v : s || w || c || i || v,
    updateValidation(R) {
      l === "aria" && !mn(v, R) ? $(R) : m.current = R;
    },
    resetValidation() {
      let R = Ze;
      mn(R, y.current) || (y.current = R, $(R)), l === "native" && A(!1), f(!0);
    },
    commitValidation() {
      l === "native" && A(!0), f(!0);
    }
  };
}
function kn(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Rl(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean")
      return kn(n);
  }
  return [];
}
function Tr(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Ho
  } : null;
}
function mn(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
function Fl(e, t, n) {
  let { isDisabled: r = !1, isReadOnly: o = !1, value: i, name: a, children: l, "aria-label": s, "aria-labelledby": c, validationState: d = "valid", isInvalid: h } = e, b = (O) => {
    O.stopPropagation(), t.setSelected(O.target.checked);
  }, u = l != null, g = s != null || c != null;
  !u && !g && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: f, isPressed: w } = gr({
    isDisabled: r
  }), { pressProps: m, isPressed: v } = gr({
    isDisabled: r || o,
    onPress() {
      t.toggle();
    }
  }), { focusableProps: $ } = ko(e, n), y = oe(f, $), T = qt(e, {
    labelable: !0
  });
  return wo(n, t.isSelected, t.setSelected), {
    labelProps: oe(m, {
      onClick: (O) => O.preventDefault()
    }),
    inputProps: oe(T, {
      "aria-invalid": h || d === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": o || void 0,
      onChange: b,
      disabled: r,
      ...i == null ? {} : {
        value: i
      },
      name: a,
      type: "checkbox",
      ...y
    }),
    isSelected: t.isSelected,
    isPressed: w || v,
    isDisabled: r,
    isReadOnly: o,
    isInvalid: h || d === "invalid"
  };
}
function Ko(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": o, labelElementType: i = "label" } = e;
  t = Pn(t);
  let a = Pn(), l = {};
  n ? (r = r ? `${a} ${r}` : a, l = {
    id: a,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !o && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let s = Xa({
    id: t,
    "aria-label": o,
    "aria-labelledby": r
  });
  return {
    labelProps: l,
    fieldProps: s
  };
}
function Wo(e = {}) {
  let { isReadOnly: t } = e, [n, r] = uo(e.isSelected, e.defaultSelected || !1, e.onChange);
  function o(a) {
    t || r(a);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: o,
    toggle: i
  };
}
function zo(e, t, n) {
  let r = Bo({
    ...e,
    value: t.isSelected
  }), { isInvalid: o, validationErrors: i, validationDetails: a } = r.displayValidation, { labelProps: l, inputProps: s, isSelected: c, isPressed: d, isDisabled: h, isReadOnly: b } = Fl({
    ...e,
    isInvalid: o
  }, t, n);
  Ml(e, r, n);
  let { isIndeterminate: u, isRequired: g, validationBehavior: f = "aria" } = e;
  return H(() => {
    n.current && (n.current.indeterminate = !!u);
  }), {
    labelProps: l,
    inputProps: {
      ...s,
      checked: c,
      "aria-required": g && f === "aria" || void 0,
      required: g && f === "native"
    },
    isSelected: c,
    isPressed: d,
    isDisabled: h,
    isReadOnly: b,
    isInvalid: o,
    validationErrors: i,
    validationDetails: a
  };
}
const Vl = /* @__PURE__ */ new WeakMap();
function _l(e, t, n) {
  const r = Wo({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    onChange(w) {
      w ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(w);
    }
  });
  let { name: o, descriptionId: i, errorMessageId: a, validationBehavior: l } = Vl.get(t);
  var s;
  l = (s = e.validationBehavior) !== null && s !== void 0 ? s : l;
  let { realtimeValidation: c } = Bo({
    ...e,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), d = L(Ze), h = () => {
    t.setInvalid(e.value, c.isInvalid ? c : d.current);
  };
  H(h);
  let b = t.realtimeValidation.isInvalid ? t.realtimeValidation : c, u = l === "native" ? t.displayValidation : b;
  var g;
  let f = zo({
    ...e,
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || o,
    isRequired: (g = e.isRequired) !== null && g !== void 0 ? g : t.isRequired,
    validationBehavior: l,
    [Ln]: {
      realtimeValidation: b,
      displayValidation: u,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(w) {
        d.current = w, h();
      }
    }
  }, r, n);
  return {
    ...f,
    inputProps: {
      ...f.inputProps,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? a : null,
        i
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const Sr = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Hl(e = {}) {
  let { style: t, isFocusable: n } = e, [r, o] = F(!1), { focusWithinProps: i } = Io({
    isDisabled: !n,
    onFocusWithinChange: (l) => o(l)
  }), a = Z(() => r ? t : t ? {
    ...Sr,
    ...t
  } : Sr, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...i,
      style: a
    }
  };
}
function Uo(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: o, ...i } = e, { visuallyHiddenProps: a } = Hl(e);
  return /* @__PURE__ */ z.createElement(n, oe(i, a), t);
}
const tr = /* @__PURE__ */ new WeakMap();
function Rn(e, t) {
  let n = tr.get(e);
  if (!n)
    throw new Error("Unknown slider state");
  return `${n.id}-${t}`;
}
function Bl(e, t, n) {
  let { labelProps: r, fieldProps: o } = Ko(e), i = e.orientation === "vertical";
  var a;
  tr.set(t, {
    id: (a = r.id) !== null && a !== void 0 ? a : o.id,
    "aria-describedby": e["aria-describedby"],
    "aria-details": e["aria-details"]
  });
  let { direction: l } = er(), { addGlobalListener: s, removeGlobalListener: c } = Qt();
  const d = L(null), h = l === "rtl", b = L(null), { moveProps: u } = No({
    onMoveStart() {
      b.current = null;
    },
    onMove({ deltaX: m, deltaY: v }) {
      let { height: $, width: y } = n.current.getBoundingClientRect(), T = i ? $ : y;
      b.current == null && (b.current = t.getThumbPercent(d.current) * T);
      let O = i ? v : m;
      if ((i || h) && (O = -O), b.current += O, d.current != null && n.current) {
        const A = Yn(b.current / T, 0, 1);
        t.setThumbPercent(d.current, A);
      }
    },
    onMoveEnd() {
      d.current != null && (t.setThumbDragging(d.current, !1), d.current = null);
    }
  });
  let g = L(void 0), f = (m, v, $, y) => {
    if (n.current && !e.isDisabled && t.values.every((T, O) => !t.isThumbDragging(O))) {
      let { height: T, width: O, top: A, left: p } = n.current.getBoundingClientRect(), I = i ? T : O, x = ((i ? y : $) - (i ? A : p)) / I;
      (l === "rtl" || i) && (x = 1 - x);
      let P = t.getPercentValue(x), N, M = t.values.findIndex((_) => P - _ < 0);
      if (M === 0)
        N = M;
      else if (M === -1)
        N = t.values.length - 1;
      else {
        let _ = t.values[M - 1], j = t.values[M];
        Math.abs(_ - P) < Math.abs(j - P) ? N = M - 1 : N = M;
      }
      N >= 0 && t.isThumbEditable(N) ? (m.preventDefault(), d.current = N, t.setFocusedThumb(N), g.current = v, t.setThumbDragging(d.current, !0), t.setThumbValue(N, P), s(window, "mouseup", w, !1), s(window, "touchend", w, !1), s(window, "pointerup", w, !1)) : d.current = null;
    }
  }, w = (m) => {
    var v, $;
    (($ = m.pointerId) !== null && $ !== void 0 ? $ : (v = m.changedTouches) === null || v === void 0 ? void 0 : v[0].identifier) === g.current && (d.current != null && (t.setThumbDragging(d.current, !1), d.current = null), c(window, "mouseup", w, !1), c(window, "touchend", w, !1), c(window, "pointerup", w, !1));
  };
  return "htmlFor" in r && r.htmlFor && (delete r.htmlFor, r.onClick = () => {
    var m;
    (m = document.getElementById(Rn(t, 0))) === null || m === void 0 || m.focus(), Mo("keyboard");
  }), {
    labelProps: r,
    // The root element of the Slider will have role="group" to group together
    // all the thumb inputs in the Slider.  The label of the Slider will
    // be used to label the group.
    groupProps: {
      role: "group",
      ...o
    },
    trackProps: oe({
      onMouseDown(m) {
        m.button !== 0 || m.altKey || m.ctrlKey || m.metaKey || f(m, void 0, m.clientX, m.clientY);
      },
      onPointerDown(m) {
        m.pointerType === "mouse" && (m.button !== 0 || m.altKey || m.ctrlKey || m.metaKey) || f(m, m.pointerId, m.clientX, m.clientY);
      },
      onTouchStart(m) {
        f(m, m.changedTouches[0].identifier, m.changedTouches[0].clientX, m.changedTouches[0].clientY);
      },
      style: {
        position: "relative",
        touchAction: "none"
      }
    }, u),
    outputProps: {
      htmlFor: t.values.map((m, v) => Rn(t, v)).join(" "),
      "aria-live": "off"
    }
  };
}
function Kl(e, t) {
  let { index: n = 0, isRequired: r, validationState: o, isInvalid: i, trackRef: a, inputRef: l, orientation: s = t.orientation, name: c } = e, d = e.isDisabled || t.isDisabled, h = s === "vertical", { direction: b } = er(), { addGlobalListener: u, removeGlobalListener: g } = Qt(), f = tr.get(t);
  var w;
  const { labelProps: m, fieldProps: v } = Ko({
    ...e,
    id: Rn(t, n),
    "aria-labelledby": `${f.id} ${(w = e["aria-labelledby"]) !== null && w !== void 0 ? w : ""}`.trim()
  }), $ = t.values[n], y = K(() => {
    l.current && ke(l.current);
  }, [
    l
  ]), T = t.focusedThumb === n;
  H(() => {
    T && y();
  }, [
    T,
    y
  ]);
  let O = b === "rtl", A = L(null), { keyboardProps: p } = Ao({
    onKeyDown(M) {
      let { getThumbMaxValue: _, getThumbMinValue: j, decrementThumb: q, incrementThumb: $e, setThumbValue: D, setThumbDragging: U, pageSize: J } = t;
      if (!/^(PageUp|PageDown|Home|End)$/.test(M.key)) {
        M.continuePropagation();
        return;
      }
      switch (M.preventDefault(), U(n, !0), M.key) {
        case "PageUp":
          $e(n, J);
          break;
        case "PageDown":
          q(n, J);
          break;
        case "Home":
          D(n, j(n));
          break;
        case "End":
          D(n, _(n));
          break;
      }
      U(n, !1);
    }
  }), { moveProps: I } = No({
    onMoveStart() {
      A.current = null, t.setThumbDragging(n, !0);
    },
    onMove({ deltaX: M, deltaY: _, pointerType: j, shiftKey: q }) {
      const { getThumbPercent: $e, setThumbPercent: D, decrementThumb: U, incrementThumb: J, step: se, pageSize: le } = t;
      let { width: ce, height: B } = a.current.getBoundingClientRect(), X = h ? B : ce;
      if (A.current == null && (A.current = $e(n) * X), j === "keyboard")
        M > 0 && O || M < 0 && !O || _ > 0 ? U(n, q ? le : se) : J(n, q ? le : se);
      else {
        let te = h ? _ : M;
        (h || O) && (te = -te), A.current += te, D(n, Yn(A.current / X, 0, 1));
      }
    },
    onMoveEnd() {
      t.setThumbDragging(n, !1);
    }
  });
  t.setThumbEditable(n, !d);
  const { focusableProps: R } = ko(oe(e, {
    onFocus: () => t.setFocusedThumb(n),
    onBlur: () => t.setFocusedThumb(void 0)
  }), l);
  let E = L(void 0), k = (M) => {
    y(), E.current = M, t.setThumbDragging(n, !0), u(window, "mouseup", x, !1), u(window, "touchend", x, !1), u(window, "pointerup", x, !1);
  }, x = (M) => {
    var _, j;
    ((j = M.pointerId) !== null && j !== void 0 ? j : (_ = M.changedTouches) === null || _ === void 0 ? void 0 : _[0].identifier) === E.current && (y(), t.setThumbDragging(n, !1), g(window, "mouseup", x, !1), g(window, "touchend", x, !1), g(window, "pointerup", x, !1));
  }, P = t.getThumbPercent(n);
  (h || b === "rtl") && (P = 1 - P);
  let N = d ? {} : oe(p, I, {
    onMouseDown: (M) => {
      M.button !== 0 || M.altKey || M.ctrlKey || M.metaKey || k();
    },
    onPointerDown: (M) => {
      M.button !== 0 || M.altKey || M.ctrlKey || M.metaKey || k(M.pointerId);
    },
    onTouchStart: (M) => {
      k(M.changedTouches[0].identifier);
    }
  });
  return wo(l, $, (M) => {
    t.setThumbValue(n, M);
  }), {
    inputProps: oe(R, v, {
      type: "range",
      tabIndex: d ? void 0 : 0,
      min: t.getThumbMinValue(n),
      max: t.getThumbMaxValue(n),
      step: t.step,
      value: $,
      name: c,
      disabled: d,
      "aria-orientation": s,
      "aria-valuetext": t.getThumbValueLabel(n),
      "aria-required": r || void 0,
      "aria-invalid": i || o === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-describedby": [
        f["aria-describedby"],
        e["aria-describedby"]
      ].filter(Boolean).join(" "),
      "aria-details": [
        f["aria-details"],
        e["aria-details"]
      ].filter(Boolean).join(" "),
      onChange: (M) => {
        t.setThumbValue(n, parseFloat(M.target.value));
      }
    }),
    thumbProps: {
      ...N,
      style: {
        position: "absolute",
        [h ? "top" : "left"]: `${P * 100}%`,
        transform: "translate(-50%, -50%)",
        touchAction: "none"
      }
    },
    labelProps: m,
    isDragging: t.isThumbDragging(n),
    isDisabled: d,
    isFocused: T
  };
}
const Wl = 0, zl = 100, Ul = 1;
function jl(e) {
  const { isDisabled: t = !1, minValue: n = Wl, maxValue: r = zl, numberFormatter: o, step: i = Ul, orientation: a = "horizontal" } = e;
  let l = Z(() => {
    let D = (r - n) / 10;
    return D = dt(D, 0, D + i, i), Math.max(D, i);
  }, [
    i,
    r,
    n
  ]), s = K((D) => D == null ? void 0 : D.map((U, J) => {
    let se = J === 0 ? n : U[J - 1], le = J === D.length - 1 ? r : U[J + 1];
    return dt(U, se, le, i);
  }), [
    n,
    r,
    i
  ]), c = Z(() => s(Cr(e.value)), [
    e.value
  ]), d = Z(() => {
    var D;
    return s((D = Cr(e.defaultValue)) !== null && D !== void 0 ? D : [
      n
    ]);
  }, [
    e.defaultValue,
    n
  ]), h = Dr(e.value, e.defaultValue, e.onChange), b = Dr(e.value, e.defaultValue, e.onChangeEnd);
  const [u, g] = uo(c, d, h), [f, w] = F(new Array(u.length).fill(!1)), m = L(new Array(u.length).fill(!0)), [v, $] = F(void 0), y = L(u), T = L(f);
  let O = (D) => {
    y.current = D, g(D);
  }, A = (D) => {
    T.current = D, w(D);
  };
  function p(D) {
    return (D - n) / (r - n);
  }
  function I(D) {
    return D === 0 ? n : u[D - 1];
  }
  function R(D) {
    return D === u.length - 1 ? r : u[D + 1];
  }
  function E(D) {
    return m.current[D];
  }
  function k(D, U) {
    m.current[D] = U;
  }
  function x(D, U) {
    if (t || !E(D))
      return;
    const J = I(D), se = R(D);
    U = dt(U, J, se, i);
    let le = Er(y.current, D, U);
    O(le);
  }
  function P(D, U) {
    if (t || !E(D))
      return;
    U && (y.current = u);
    const J = T.current[D];
    T.current = Er(T.current, D, U), A(T.current), b && J && !T.current.some(Boolean) && b(y.current);
  }
  function N(D) {
    return o.format(D);
  }
  function M(D, U) {
    x(D, j(U));
  }
  function _(D) {
    return Math.round((D - n) / i) * i + n;
  }
  function j(D) {
    const U = D * (r - n) + n;
    return Yn(_(U), n, r);
  }
  function q(D, U = 1) {
    let J = Math.max(U, i);
    x(D, dt(u[D] + J, n, r, i));
  }
  function $e(D, U = 1) {
    let J = Math.max(U, i);
    x(D, dt(u[D] - J, n, r, i));
  }
  return {
    values: u,
    getThumbValue: (D) => u[D],
    setThumbValue: x,
    setThumbPercent: M,
    isThumbDragging: (D) => f[D],
    setThumbDragging: P,
    focusedThumb: v,
    setFocusedThumb: $,
    getThumbPercent: (D) => p(u[D]),
    getValuePercent: p,
    getThumbValueLabel: (D) => N(u[D]),
    getFormattedValue: N,
    getThumbMinValue: I,
    getThumbMaxValue: R,
    getPercentValue: j,
    isThumbEditable: E,
    setThumbEditable: k,
    incrementThumb: q,
    decrementThumb: $e,
    step: i,
    pageSize: l,
    orientation: a,
    isDisabled: t
  };
}
function Er(e, t, n) {
  return e[t] === n ? e : [
    ...e.slice(0, t),
    n,
    ...e.slice(t + 1)
  ];
}
function Cr(e) {
  if (e != null)
    return Array.isArray(e) ? e : [
      e
    ];
}
function Dr(e, t, n) {
  return (r) => {
    typeof e == "number" || typeof t == "number" ? n == null || n(r[0]) : n == null || n(r);
  };
}
function Xl(e, t, n) {
  let r = Gn(), o = L(r);
  o.current = r;
  let i = K(() => o.current ? n() : t(), [
    t,
    n
  ]);
  return da.useSyncExternalStore(e, i);
}
typeof z.useSyncExternalStore == "function" && z.useSyncExternalStore;
const Yl = Symbol("callback"), Or = Symbol("default");
function jo({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ z.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function $t(e) {
  let { className: t, style: n, children: r, defaultClassName: o, defaultChildren: i, values: a } = e;
  return Z(() => {
    let l, s, c;
    return typeof t == "function" ? l = t(a) : l = t, typeof n == "function" ? s = n(a) : s = n, typeof r == "function" ? c = r(a) : r == null ? c = i : c = r, {
      className: l ?? o,
      style: s,
      children: c,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    o,
    i,
    a
  ]);
}
function Xo(e, t) {
  let n = ae(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = new Intl.ListFormat().format(Object.keys(n.slots).map((i) => `"${i}"`));
    if (!t && !n.slots[Or])
      throw new Error(`A slot prop is required. Valid slot names are ${r}.`);
    let o = t || Or;
    if (!n.slots[o])
      throw new Error(`Invalid slot "${t}". Valid slot names are ${r}.`);
    return n.slots[o];
  }
  return n;
}
function yt(e, t, n) {
  let r = Xo(n, e.slot) || {}, { ref: o, [Yl]: i, ...a } = r, l = Ya(Z(() => ka(t, o), [
    t,
    o
  ])), s = oe(a, e);
  return "style" in a && a.style && typeof a.style == "object" && "style" in e && e.style && typeof e.style == "object" && (s.style = {
    ...a.style,
    ...e.style
  }), H(() => {
    i && i(e);
  }, [
    i,
    e
  ]), [
    s,
    l
  ];
}
function Yo() {
  let [e, t] = F(!0), n = L(!1), r = K((o) => {
    n.current = !0, t(!!o);
  }, []);
  return it(() => {
    n.current || t(!1);
  }, []), [
    r,
    e
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const Gl = /* @__PURE__ */ de(!1);
typeof DocumentFragment < "u" && new DocumentFragment();
function ql(e) {
  let t = (n, r) => ae(Gl) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, z.forwardRef(t);
}
const nr = /* @__PURE__ */ de({});
function Zl(e, t) {
  [e, t] = yt(e, t, nr);
  let { elementType: n = "label", ...r } = e;
  return /* @__PURE__ */ z.createElement(n, {
    className: "react-aria-Label",
    ...r,
    ref: t
  });
}
const Ql = /* @__PURE__ */ ql(Zl), Jl = /* @__PURE__ */ de(null), es = /* @__PURE__ */ de(null);
function ts(e, t) {
  [e, t] = yt(e, t, es);
  let n = L(null), r = ae(Jl);
  var o;
  let { labelProps: i, inputProps: a, isSelected: l, isDisabled: s, isReadOnly: c, isPressed: d, isInvalid: h } = r ? _l({
    ...e,
    // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
    // it's passed explicitly here to avoid typescript error (requires ignore).
    // @ts-ignore
    value: e.value,
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, r, n) : zo({
    ...e,
    children: typeof e.children == "function" ? !0 : e.children,
    validationBehavior: (o = e.validationBehavior) !== null && o !== void 0 ? o : "native"
  }, Wo(e), n), { isFocused: b, isFocusVisible: u, focusProps: g } = Lo(), f = s || c, { hoverProps: w, isHovered: m } = Qn({
    ...e,
    isDisabled: f
  }), v = $t({
    // TODO: should data attrs go on the label or on the <input>? useCheckbox passes them to the input...
    ...e,
    defaultClassName: "react-aria-Checkbox",
    values: {
      isSelected: l,
      isIndeterminate: e.isIndeterminate || !1,
      isPressed: d,
      isHovered: m,
      isFocused: b,
      isFocusVisible: u,
      isDisabled: s,
      isReadOnly: c,
      isInvalid: h,
      isRequired: e.isRequired || !1
    }
  }), $ = qt(e);
  return delete $.id, /* @__PURE__ */ z.createElement("label", {
    ...oe($, i, w, v),
    ref: t,
    slot: e.slot || void 0,
    "data-selected": l || void 0,
    "data-indeterminate": e.isIndeterminate || void 0,
    "data-pressed": d || void 0,
    "data-hovered": m || void 0,
    "data-focused": b || void 0,
    "data-focus-visible": u || void 0,
    "data-disabled": s || void 0,
    "data-readonly": c || void 0,
    "data-invalid": h || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ z.createElement(Uo, {
    elementType: "span"
  }, /* @__PURE__ */ z.createElement("input", {
    ...oe(a, g),
    ref: n
  })), v.children);
}
const ns = /* @__PURE__ */ V(ts), rs = /* @__PURE__ */ de(null), en = /* @__PURE__ */ de(null), rr = /* @__PURE__ */ de(null), Go = /* @__PURE__ */ de(null);
function os(e, t) {
  [e, t] = yt(e, t, rs);
  let n = L(null), r = Dl(e.formatOptions), o = jl({
    ...e,
    numberFormatter: r
  }), [i, a] = Yo(), { groupProps: l, trackProps: s, labelProps: c, outputProps: d } = Bl({
    ...e,
    label: a
  }, o, n), h = $t({
    ...e,
    values: {
      orientation: o.orientation,
      isDisabled: o.isDisabled,
      state: o
    },
    defaultClassName: "react-aria-Slider"
  }), b = qt(e);
  return delete b.id, /* @__PURE__ */ z.createElement(jo, {
    values: [
      [
        en,
        o
      ],
      [
        rr,
        {
          ...s,
          ref: n
        }
      ],
      [
        Go,
        d
      ],
      [
        nr,
        {
          ...c,
          ref: i
        }
      ]
    ]
  }, /* @__PURE__ */ z.createElement("div", {
    ...b,
    ...l,
    ...h,
    ref: t,
    slot: e.slot || void 0,
    "data-orientation": o.orientation,
    "data-disabled": o.isDisabled || void 0
  }));
}
const is = /* @__PURE__ */ V(os);
function as(e, t) {
  [e, t] = yt(e, t, Go);
  let { children: n, style: r, className: o, ...i } = e, a = ae(en), l = $t({
    className: o,
    style: r,
    children: n,
    defaultChildren: a.getThumbValueLabel(0),
    defaultClassName: "react-aria-SliderOutput",
    values: {
      orientation: a.orientation,
      isDisabled: a.isDisabled,
      state: a
    }
  });
  return /* @__PURE__ */ z.createElement("output", {
    ...i,
    ...l,
    ref: t,
    "data-orientation": a.orientation || void 0,
    "data-disabled": a.isDisabled || void 0
  });
}
const ls = /* @__PURE__ */ V(as);
function ss(e, t) {
  [e, t] = yt(e, t, rr);
  let n = ae(en), { onHoverStart: r, onHoverEnd: o, onHoverChange: i, ...a } = e, { hoverProps: l, isHovered: s } = Qn({
    onHoverStart: r,
    onHoverEnd: o,
    onHoverChange: i
  }), c = $t({
    ...e,
    defaultClassName: "react-aria-SliderTrack",
    values: {
      orientation: n.orientation,
      isDisabled: n.isDisabled,
      isHovered: s,
      state: n
    }
  });
  return /* @__PURE__ */ z.createElement("div", {
    ...oe(a, l),
    ...c,
    ref: t,
    "data-hovered": s || void 0,
    "data-orientation": n.orientation || void 0,
    "data-disabled": n.isDisabled || void 0
  });
}
const cs = /* @__PURE__ */ V(ss);
function ds(e, t) {
  let n = ae(en), { ref: r } = Xo(rr), { index: o = 0 } = e, i = L(null), [a, l] = Yo(), { thumbProps: s, inputProps: c, labelProps: d, isDragging: h, isFocused: b, isDisabled: u } = Kl({
    ...e,
    index: o,
    trackRef: r,
    inputRef: i,
    label: l
  }, n), { focusProps: g, isFocusVisible: f } = Lo(), { hoverProps: w, isHovered: m } = Qn(e), v = $t({
    ...e,
    defaultClassName: "react-aria-SliderThumb",
    values: {
      state: n,
      isHovered: m,
      isDragging: h,
      isFocused: b,
      isFocusVisible: f,
      isDisabled: u
    }
  }), $ = qt(e);
  return delete $.id, /* @__PURE__ */ z.createElement("div", {
    ...oe($, s, w),
    ...v,
    ref: t,
    style: {
      ...s.style,
      ...v.style
    },
    "data-hovered": m || void 0,
    "data-dragging": h || void 0,
    "data-focused": b || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": u || void 0
  }, /* @__PURE__ */ z.createElement(Uo, null, /* @__PURE__ */ z.createElement("input", {
    ref: i,
    ...oe(c, g)
  })), /* @__PURE__ */ z.createElement(jo, {
    values: [
      [
        nr,
        {
          ...d,
          ref: a
        }
      ]
    ]
  }, v.children));
}
const us = /* @__PURE__ */ V(ds);
function fs({
  label: e,
  thumbLabels: t,
  ...n
}) {
  return S(is, {
    ...n,
    className: ie("tw-grid tw-grid-cols-[1fr_auto] tw-items-center tw-gap-2", n.className),
    children: [e && S(Ql, {
      children: e
    }), S(ls, {
      className: "tw-text-end",
      children: ({
        state: r
      }) => r.values.map((o, i) => ua(r.getThumbValue(i) * 100)).join("–")
    }), S(cs, {
      className: "tw-col-span-2 tw-mx-3 tw-flex tw-h-6 tw-items-center",
      children: ({
        state: r
      }) => S(Ae, {
        children: [S("div", {
          className: "tw-absolute tw-top-1/2 !tw-block tw-h-1.5 tw-w-full -tw-translate-y-1/2 tw-rounded-full tw-bg-box-background"
        }), S("div", {
          className: "tw-absolute tw-top-1/2 !tw-block tw-h-1.5 tw-w-full -tw-translate-y-1/2 tw-rounded-full tw-bg-border",
          style: {
            width: (Math.abs(r.getThumbPercent(0) - r.getThumbPercent(1)) * 100).toFixed(2) + "%",
            left: r.getThumbPercent(0) * 100 + "%"
          }
        }), r.values.map((o, i) => S(us, {
          index: i,
          "aria-label": t == null ? void 0 : t[i],
          className: "tw-mt-5 tw-h-5 tw-w-5 tw-rounded-full tw-bg-brand-primary"
        }, i))]
      })
    })]
  });
}
const ps = ({
  className: e,
  children: t,
  ...n
}) => S(ns, {
  className: (r) => ie("tw-group tw-flex tw-items-center tw-gap-x-2 data-[disabled]:tw-cursor-not-allowed data-[disabled]:tw-opacity-50", typeof e == "function" ? e(r) : e),
  ...n,
  children: (r) => S(Ae, {
    children: [S("div", {
      className: "group-data-[focus-visible]:tw-ring-ring !tw-flex tw-h-5 tw-w-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-sm tw-border tw-border-primary tw-ring-offset-background group-data-[indeterminate]:tw-bg-box-background group-data-[focus-visible]:tw-outline-none group-data-[focus-visible]:tw-ring-2 group-data-[focus-visible]:tw-ring-offset-2",
      children: r.isIndeterminate ? S(Pa, {
        className: "tw-h-[0.875rem] tw-w-[0.875rem]"
      }) : r.isSelected ? S(so, {
        size: 18
      }) : null
    }), typeof t == "function" ? t(r) : t]
  })
}), vs = oo((e) => {
  const {
    facets: t
  } = e.controller.store;
  return S("div", {
    className: "tw-w-full",
    children: t.map((n) => n.display === "slider" ? S(ms, {
      facet: n
    }) : S("details", {
      open: !n.collapsed,
      onChange: () => n.toggleCollapse(),
      className: "tw-group tw-border-b tw-border-b-border tw-px-1.5 tw-pb-7",
      children: [S("summary", {
        className: "tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pt-7 group-open:tw-pb-7",
        children: [S("span", {
          class: "tw-block tw-overflow-hidden tw-text-wrap tw-break-words",
          children: n.label
        }), S("span", {
          className: "tw-block tw-flex-shrink-0 tw-transition-transform group-open:tw-rotate-180",
          children: S(Xn, {
            size: 14
          })
        })]
      }), n.display === "list" && S(bs, {
        facet: n
      }), n.display === "palette" && S(hs, {
        facet: n
      }), n.display === "grid" && S(gs, {
        facet: n
      })]
    }))
  });
}), ms = (e) => {
  if (e.facet.display !== "slider")
    return null;
  const t = e.facet, n = (r) => {
    var o;
    (o = t == null ? void 0 : t.services) != null && o.urlManager && (r[0] == t.range.low && r[1] == t.range.high ? t.services.urlManager.remove("page").remove(`filter.${t.field}`).go() : t.services.urlManager.remove("page").set(`filter.${t.field}`, {
      low: r[0],
      high: r[1]
    }).go());
  };
  return S("div", {
    className: "tw-border-b tw-border-border tw-py-7",
    children: S(fs, {
      defaultValue: [t.range.low, t.range.high],
      label: e.facet.label,
      step: t.step,
      maxValue: t.range.high,
      minValue: t.range.low,
      formatOptions: {},
      onChangeEnd: n
    })
  });
}, hs = (e) => {
  if (e.facet.display !== "palette")
    return null;
  const t = e.facet;
  return S("ul", {
    className: "tw-grid tw-grid-cols-3 tw-gap-5",
    children: t.values.map((n) => {
      var r;
      return S("a", {
        href: (r = n.url) == null ? void 0 : r.link.href,
        onClick: (o) => {
          var i, a;
          return (a = (i = n.url) == null ? void 0 : i.link) == null ? void 0 : a.onClick(o);
        },
        "aria-label": n.filtered ? `remove selected filter ${(t == null ? void 0 : t.label) || ""} - ${n.label}` : t != null && t.label ? `filter by ${t == null ? void 0 : t.label} - ${n.label}` : `filter by ${n.label}`,
        className: "tw-flex tw-flex-col tw-items-center tw-gap-1.5 tw-overflow-hidden",
        children: [S("div", {
          className: ie("tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-transparent tw-p-1", n.filtered && "tw-border-border"),
          children: S("span", {
            style: `background-color: lightgray; background-color: ${n.value}`,
            className: "tw-block tw-h-full tw-w-full tw-rounded-full"
          })
        }), S("span", {
          className: "tw-typ-small-1 tw-block tw-w-full tw-overflow-hidden tw-text-wrap tw-break-words tw-text-center",
          children: n.label
        })]
      }, n.value);
    })
  });
}, gs = (e) => {
  const t = fa();
  if (e.facet.display !== "grid")
    return null;
  const n = e.facet;
  return S("div", {
    class: "tw-flex tw-flex-wrap tw-gap-[18px]",
    children: n.values.map((r) => {
      var o;
      return S("a", {
        href: (o = r.url) == null ? void 0 : o.link.href,
        "aria-label": r.filtered ? `remove selected filter ${(n == null ? void 0 : n.label) || ""} - ${r.label}` : n != null && n.label ? `filter by ${n == null ? void 0 : n.label} - ${r.label}` : `filter by ${r.label}`,
        onClick: (i) => {
          var a, l;
          (l = (a = r.url) == null ? void 0 : a.link) == null || l.onClick(i);
        },
        children: [S("input", {
          className: "tw-peer tw-sr-only",
          type: "checkbox",
          checked: r.filtered,
          htmlFor: r.url.href + t
        }), S("label", {
          id: r.url.href + t,
          className: ie("tw-typ-body-2 tw-flex tw-min-h-[34px] tw-min-w-[36px] tw-items-center tw-justify-center tw-border tw-border-solid tw-p-1", r.filtered ? "tw-border-brand-primary" : "tw-border-box-background"),
          children: r.label
        })]
      });
    })
  });
}, bs = (e) => {
  if (e.facet.display !== "list")
    return null;
  const t = e.facet;
  return S("div", {
    class: "tw-flex tw-flex-col tw-gap-5",
    children: t.values.map((n) => {
      var r;
      return S("a", {
        className: "tw-typ-body-3 tw-flex tw-cursor-pointer tw-items-center tw-gap-2",
        href: (r = n.url) == null ? void 0 : r.link.href,
        "aria-label": n.filtered ? `remove selected filter ${(t == null ? void 0 : t.label) || ""} - ${n.label}` : t != null && t.label ? `filter by ${t == null ? void 0 : t.label} - ${n.label}` : `filter by ${n.label}`,
        onClick: (o) => {
          var i, a;
          (a = (i = n.url) == null ? void 0 : i.link) == null || a.onClick(o);
        },
        children: S(ps, {
          className: "tw-pointer-events-none",
          isReadOnly: !0,
          isSelected: n.filtered,
          children: `${n.label} (${n.count})`
        })
      });
    })
  });
}, Mr = ya(vs);
function Ir(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function ee(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function tn(e, t = []) {
  let n = [];
  function r(i, a) {
    const l = /* @__PURE__ */ de(a), s = n.length;
    n = [
      ...n,
      a
    ];
    function c(h) {
      const { scope: b, children: u, ...g } = h, f = (b == null ? void 0 : b[e][s]) || l, w = Z(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ C(f.Provider, {
        value: w
      }, u);
    }
    function d(h, b) {
      const u = (b == null ? void 0 : b[e][s]) || l, g = ae(u);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      d
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ de(a));
    return function(l) {
      const s = (l == null ? void 0 : l[e]) || i;
      return Z(
        () => ({
          [`__scope${e}`]: {
            ...l,
            [e]: s
          }
        }),
        [
          l,
          s
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    ws(o, ...t)
  ];
}
function ws(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((l, { useScope: s, scopeName: c }) => {
        const h = s(i)[`__scope${c}`];
        return {
          ...l,
          ...h
        };
      }, {});
      return Z(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function $s(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function qo(...e) {
  return (t) => e.forEach(
    (n) => $s(n, t)
  );
}
function re(...e) {
  return K(qo(...e), e);
}
const tt = /* @__PURE__ */ V((e, t) => {
  const { children: n, ...r } = e, o = Re.toArray(n), i = o.find(xs);
  if (i) {
    const a = i.props.children, l = o.map((s) => s === i ? Re.count(a) > 1 ? Re.only(null) : /* @__PURE__ */ Vt(a) ? a.props.children : null : s);
    return /* @__PURE__ */ C(Fn, W({}, r, {
      ref: t
    }), /* @__PURE__ */ Vt(a) ? /* @__PURE__ */ Yt(a, void 0, l) : null);
  }
  return /* @__PURE__ */ C(Fn, W({}, r, {
    ref: t
  }), n);
});
tt.displayName = "Slot";
const Fn = /* @__PURE__ */ V((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Vt(n) ? /* @__PURE__ */ Yt(n, {
    ...Ps(r, n.props),
    ref: t ? qo(t, n.ref) : n.ref
  }) : Re.count(n) > 1 ? Re.only(null) : null;
});
Fn.displayName = "SlotClone";
const ys = ({ children: e }) => /* @__PURE__ */ C(Ae, null, e);
function xs(e) {
  return /* @__PURE__ */ Vt(e) && e.type === ys;
}
function Ps(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...l) => {
      i(...l), o(...l);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Ts(e) {
  const t = e + "CollectionProvider", [n, r] = tn(t), [o, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (u) => {
    const { scope: g, children: f } = u, w = z.useRef(null), m = z.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ z.createElement(o, {
      scope: g,
      itemMap: m,
      collectionRef: w
    }, f);
  }, l = e + "CollectionSlot", s = /* @__PURE__ */ z.forwardRef((u, g) => {
    const { scope: f, children: w } = u, m = i(l, f), v = re(g, m.collectionRef);
    return /* @__PURE__ */ z.createElement(tt, {
      ref: v
    }, w);
  }), c = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ z.forwardRef((u, g) => {
    const { scope: f, children: w, ...m } = u, v = z.useRef(null), $ = re(g, v), y = i(c, f);
    return z.useEffect(() => (y.itemMap.set(v, {
      ref: v,
      ...m
    }), () => void y.itemMap.delete(v))), /* @__PURE__ */ z.createElement(tt, {
      [d]: "",
      ref: $
    }, w);
  });
  function b(u) {
    const g = i(e + "CollectionConsumer", u);
    return z.useCallback(() => {
      const w = g.collectionRef.current;
      if (!w)
        return [];
      const m = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (y, T) => m.indexOf(y.ref.current) - m.indexOf(T.ref.current)
      );
    }, [
      g.collectionRef,
      g.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: s,
      ItemSlot: h
    },
    b,
    r
  ];
}
const Ss = /* @__PURE__ */ de(void 0);
function Es(e) {
  const t = ae(Ss);
  return e || t || "ltr";
}
const Cs = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ne = Cs.reduce((e, t) => {
  const n = /* @__PURE__ */ V((r, o) => {
    const { asChild: i, ...a } = r, l = i ? tt : t;
    return H(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ C(l, W({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Ds(e, t) {
  e && jn(
    () => e.dispatchEvent(t)
  );
}
function De(e) {
  const t = L(e);
  return H(() => {
    t.current = e;
  }), Z(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Os(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e);
  H(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Vn = "dismissableLayer.update", Ms = "dismissableLayer.pointerDownOutside", Is = "dismissableLayer.focusOutside";
let Ar;
const As = /* @__PURE__ */ de({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zo = /* @__PURE__ */ V((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: l, onDismiss: s, ...c } = e, d = ae(As), [h, b] = F(null), u = (n = h == null ? void 0 : h.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = F({}), f = re(
    t,
    (p) => b(p)
  ), w = Array.from(d.layers), [m] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = w.indexOf(m), $ = h ? w.indexOf(h) : -1, y = d.layersWithOutsidePointerEventsDisabled.size > 0, T = $ >= v, O = Ns((p) => {
    const I = p.target, R = [
      ...d.branches
    ].some(
      (E) => E.contains(I)
    );
    !T || R || (i == null || i(p), l == null || l(p), p.defaultPrevented || s == null || s());
  }, u), A = Ls((p) => {
    const I = p.target;
    [
      ...d.branches
    ].some(
      (E) => E.contains(I)
    ) || (a == null || a(p), l == null || l(p), p.defaultPrevented || s == null || s());
  }, u);
  return Os((p) => {
    $ === d.layers.size - 1 && (o == null || o(p), !p.defaultPrevented && s && (p.preventDefault(), s()));
  }, u), H(() => {
    if (h)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Ar = u.body.style.pointerEvents, u.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(h)), d.layers.add(h), Nr(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (u.body.style.pointerEvents = Ar);
      };
  }, [
    h,
    u,
    r,
    d
  ]), H(() => () => {
    h && (d.layers.delete(h), d.layersWithOutsidePointerEventsDisabled.delete(h), Nr());
  }, [
    h,
    d
  ]), H(() => {
    const p = () => g({});
    return document.addEventListener(Vn, p), () => document.removeEventListener(Vn, p);
  }, []), /* @__PURE__ */ C(ne.div, W({}, c, {
    ref: f,
    style: {
      pointerEvents: y ? T ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: ee(e.onFocusCapture, A.onFocusCapture),
    onBlurCapture: ee(e.onBlurCapture, A.onBlurCapture),
    onPointerDownCapture: ee(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
});
function Ns(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e), r = L(!1), o = L(() => {
  });
  return H(() => {
    const i = (l) => {
      if (l.target && !r.current) {
        let c = function() {
          Qo(Ms, n, s, {
            discrete: !0
          });
        };
        const s = {
          originalEvent: l
        };
        l.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ls(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e), r = L(!1);
  return H(() => {
    const o = (i) => {
      i.target && !r.current && Qo(Is, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Nr() {
  const e = new CustomEvent(Vn);
  document.dispatchEvent(e);
}
function Qo(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ds(o, i) : o.dispatchEvent(i);
}
let hn = 0;
function Jo() {
  H(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Lr()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Lr()), hn++, () => {
      hn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), hn--;
    };
  }, []);
}
function Lr() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const gn = "focusScope.autoFocusOnMount", bn = "focusScope.autoFocusOnUnmount", kr = {
  bubbles: !1,
  cancelable: !0
}, ei = /* @__PURE__ */ V((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [l, s] = F(null), c = De(o), d = De(i), h = L(null), b = re(
    t,
    (f) => s(f)
  ), u = L({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  H(() => {
    if (r) {
      let f = function($) {
        if (u.paused || !l)
          return;
        const y = $.target;
        l.contains(y) ? h.current = y : Le(h.current, {
          select: !0
        });
      }, w = function($) {
        if (u.paused || !l)
          return;
        const y = $.relatedTarget;
        y !== null && (l.contains(y) || Le(h.current, {
          select: !0
        }));
      }, m = function($) {
        if (document.activeElement === document.body)
          for (const T of $)
            T.removedNodes.length > 0 && Le(l);
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", w);
      const v = new MutationObserver(m);
      return l && v.observe(l, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", w), v.disconnect();
      };
    }
  }, [
    r,
    l,
    u.paused
  ]), H(() => {
    if (l) {
      Fr.add(u);
      const f = document.activeElement;
      if (!l.contains(f)) {
        const m = new CustomEvent(gn, kr);
        l.addEventListener(gn, c), l.dispatchEvent(m), m.defaultPrevented || (ks(Hs(ti(l)), {
          select: !0
        }), document.activeElement === f && Le(l));
      }
      return () => {
        l.removeEventListener(gn, c), setTimeout(() => {
          const m = new CustomEvent(bn, kr);
          l.addEventListener(bn, d), l.dispatchEvent(m), m.defaultPrevented || Le(f ?? document.body, {
            select: !0
          }), l.removeEventListener(bn, d), Fr.remove(u);
        }, 0);
      };
    }
  }, [
    l,
    c,
    d,
    u
  ]);
  const g = K((f) => {
    if (!n && !r || u.paused)
      return;
    const w = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, m = document.activeElement;
    if (w && m) {
      const v = f.currentTarget, [$, y] = Rs(v);
      $ && y ? !f.shiftKey && m === y ? (f.preventDefault(), n && Le($, {
        select: !0
      })) : f.shiftKey && m === $ && (f.preventDefault(), n && Le(y, {
        select: !0
      })) : m === v && f.preventDefault();
    }
  }, [
    n,
    r,
    u.paused
  ]);
  return /* @__PURE__ */ C(ne.div, W({
    tabIndex: -1
  }, a, {
    ref: b,
    onKeyDown: g
  }));
});
function ks(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Le(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Rs(e) {
  const t = ti(e), n = Rr(t, e), r = Rr(t.reverse(), e);
  return [
    n,
    r
  ];
}
function ti(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Rr(e, t) {
  for (const n of e)
    if (!Fs(n, {
      upTo: t
    }))
      return n;
}
function Fs(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Vs(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Le(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Vs(e) && t && e.select();
  }
}
const Fr = _s();
function _s() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Vr(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Vr(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Vr(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Hs(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const ue = globalThis != null && globalThis.document ? Gt : () => {
}, Bs = pa.useId || (() => {
});
let Ks = 0;
function vt(e) {
  const [t, n] = F(Bs());
  return ue(() => {
    e || n(
      (r) => r ?? String(Ks++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Ws = ["top", "right", "bottom", "left"], Fe = Math.min, ve = Math.max, zt = Math.round, Ct = Math.floor, Ve = (e) => ({
  x: e,
  y: e
}), zs = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Us = {
  start: "end",
  end: "start"
};
function _n(e, t, n) {
  return ve(e, Fe(t, n));
}
function Oe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Me(e) {
  return e.split("-")[0];
}
function at(e) {
  return e.split("-")[1];
}
function or(e) {
  return e === "x" ? "y" : "x";
}
function ir(e) {
  return e === "y" ? "height" : "width";
}
function lt(e) {
  return ["top", "bottom"].includes(Me(e)) ? "y" : "x";
}
function ar(e) {
  return or(lt(e));
}
function js(e, t, n) {
  n === void 0 && (n = !1);
  const r = at(e), o = ar(e), i = ir(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Ut(a)), [a, Ut(a)];
}
function Xs(e) {
  const t = Ut(e);
  return [Hn(e), t, Hn(t)];
}
function Hn(e) {
  return e.replace(/start|end/g, (t) => Us[t]);
}
function Ys(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function Gs(e, t, n, r) {
  const o = at(e);
  let i = Ys(Me(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Hn)))), i;
}
function Ut(e) {
  return e.replace(/left|right|bottom|top/g, (t) => zs[t]);
}
function qs(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ni(e) {
  return typeof e != "number" ? qs(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function jt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function _r(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = lt(t), a = ar(t), l = ir(a), s = Me(t), c = i === "y", d = r.x + r.width / 2 - o.width / 2, h = r.y + r.height / 2 - o.height / 2, b = r[l] / 2 - o[l] / 2;
  let u;
  switch (s) {
    case "top":
      u = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      u = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      u = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      u = {
        x: r.x - o.width,
        y: h
      };
      break;
    default:
      u = {
        x: r.x,
        y: r.y
      };
  }
  switch (at(t)) {
    case "start":
      u[a] -= b * (n && c ? -1 : 1);
      break;
    case "end":
      u[a] += b * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const Zs = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, l = i.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: h
  } = _r(c, r, s), b = r, u = {}, g = 0;
  for (let f = 0; f < l.length; f++) {
    const {
      name: w,
      fn: m
    } = l[f], {
      x: v,
      y: $,
      data: y,
      reset: T
    } = await m({
      x: d,
      y: h,
      initialPlacement: r,
      placement: b,
      strategy: o,
      middlewareData: u,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = v ?? d, h = $ ?? h, u = {
      ...u,
      [w]: {
        ...u[w],
        ...y
      }
    }, T && g <= 50 && (g++, typeof T == "object" && (T.placement && (b = T.placement), T.rects && (c = T.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : T.rects), {
      x: d,
      y: h
    } = _r(c, b, s)), f = -1);
  }
  return {
    x: d,
    y: h,
    placement: b,
    strategy: o,
    middlewareData: u
  };
};
async function gt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: h = "floating",
    altBoundary: b = !1,
    padding: u = 0
  } = Oe(t, e), g = ni(u), w = l[b ? h === "floating" ? "reference" : "floating" : h], m = jt(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: s
  })), v = h === "floating" ? {
    ...a.floating,
    x: r,
    y: o
  } : a.reference, $ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), y = await (i.isElement == null ? void 0 : i.isElement($)) ? await (i.getScale == null ? void 0 : i.getScale($)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = jt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: v,
    offsetParent: $,
    strategy: s
  }) : v);
  return {
    top: (m.top - T.top + g.top) / y.y,
    bottom: (T.bottom - m.bottom + g.bottom) / y.y,
    left: (m.left - T.left + g.left) / y.x,
    right: (T.right - m.right + g.right) / y.x
  };
}
const Qs = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: l,
      middlewareData: s
    } = t, {
      element: c,
      padding: d = 0
    } = Oe(e, t) || {};
    if (c == null)
      return {};
    const h = ni(d), b = {
      x: n,
      y: r
    }, u = ar(o), g = ir(u), f = await a.getDimensions(c), w = u === "y", m = w ? "top" : "left", v = w ? "bottom" : "right", $ = w ? "clientHeight" : "clientWidth", y = i.reference[g] + i.reference[u] - b[u] - i.floating[g], T = b[u] - i.reference[u], O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let A = O ? O[$] : 0;
    (!A || !await (a.isElement == null ? void 0 : a.isElement(O))) && (A = l.floating[$] || i.floating[g]);
    const p = y / 2 - T / 2, I = A / 2 - f[g] / 2 - 1, R = Fe(h[m], I), E = Fe(h[v], I), k = R, x = A - f[g] - E, P = A / 2 - f[g] / 2 + p, N = _n(k, P, x), M = !s.arrow && at(o) != null && P !== N && i.reference[g] / 2 - (P < k ? R : E) - f[g] / 2 < 0, _ = M ? P < k ? P - k : P - x : 0;
    return {
      [u]: b[u] + _,
      data: {
        [u]: N,
        centerOffset: P - N - _,
        ...M && {
          alignmentOffset: _
        }
      },
      reset: M
    };
  }
}), Js = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: h = !0,
        fallbackPlacements: b,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: f = !0,
        ...w
      } = Oe(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const m = Me(o), v = Me(l) === l, $ = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), y = b || (v || !f ? [Ut(l)] : Xs(l));
      !b && g !== "none" && y.push(...Gs(l, f, g, $));
      const T = [l, ...y], O = await gt(t, w), A = [];
      let p = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && A.push(O[m]), h) {
        const k = js(o, a, $);
        A.push(O[k[0]], O[k[1]]);
      }
      if (p = [...p, {
        placement: o,
        overflows: A
      }], !A.every((k) => k <= 0)) {
        var I, R;
        const k = (((I = i.flip) == null ? void 0 : I.index) || 0) + 1, x = T[k];
        if (x)
          return {
            data: {
              index: k,
              overflows: p
            },
            reset: {
              placement: x
            }
          };
        let P = (R = p.filter((N) => N.overflows[0] <= 0).sort((N, M) => N.overflows[1] - M.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!P)
          switch (u) {
            case "bestFit": {
              var E;
              const N = (E = p.map((M) => [M.placement, M.overflows.filter((_) => _ > 0).reduce((_, j) => _ + j, 0)]).sort((M, _) => M[1] - _[1])[0]) == null ? void 0 : E[0];
              N && (P = N);
              break;
            }
            case "initialPlacement":
              P = l;
              break;
          }
        if (o !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
function Hr(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Br(e) {
  return Ws.some((t) => e[t] >= 0);
}
const ec = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Oe(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await gt(t, {
            ...o,
            elementContext: "reference"
          }), a = Hr(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Br(a)
            }
          };
        }
        case "escaped": {
          const i = await gt(t, {
            ...o,
            altBoundary: !0
          }), a = Hr(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Br(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function tc(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Me(n), l = at(n), s = lt(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, d = i && s ? -1 : 1, h = Oe(t, e);
  let {
    mainAxis: b,
    crossAxis: u,
    alignmentAxis: g
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return l && typeof g == "number" && (u = l === "end" ? g * -1 : g), s ? {
    x: u * d,
    y: b * c
  } : {
    x: b * c,
    y: u * d
  };
}
const nc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: l
      } = t, s = await tc(t, e);
      return a === ((n = l.offset) == null ? void 0 : n.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: o + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, rc = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: m,
              y: v
            } = w;
            return {
              x: m,
              y: v
            };
          }
        },
        ...s
      } = Oe(e, t), c = {
        x: n,
        y: r
      }, d = await gt(t, s), h = lt(Me(o)), b = or(h);
      let u = c[b], g = c[h];
      if (i) {
        const w = b === "y" ? "top" : "left", m = b === "y" ? "bottom" : "right", v = u + d[w], $ = u - d[m];
        u = _n(v, u, $);
      }
      if (a) {
        const w = h === "y" ? "top" : "left", m = h === "y" ? "bottom" : "right", v = g + d[w], $ = g - d[m];
        g = _n(v, g, $);
      }
      const f = l.fn({
        ...t,
        [b]: u,
        [h]: g
      });
      return {
        ...f,
        data: {
          x: f.x - n,
          y: f.y - r
        }
      };
    }
  };
}, oc = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: l = 0,
        mainAxis: s = !0,
        crossAxis: c = !0
      } = Oe(e, t), d = {
        x: n,
        y: r
      }, h = lt(o), b = or(h);
      let u = d[b], g = d[h];
      const f = Oe(l, t), w = typeof f == "number" ? {
        mainAxis: f,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...f
      };
      if (s) {
        const $ = b === "y" ? "height" : "width", y = i.reference[b] - i.floating[$] + w.mainAxis, T = i.reference[b] + i.reference[$] - w.mainAxis;
        u < y ? u = y : u > T && (u = T);
      }
      if (c) {
        var m, v;
        const $ = b === "y" ? "width" : "height", y = ["top", "left"].includes(Me(o)), T = i.reference[h] - i.floating[$] + (y && ((m = a.offset) == null ? void 0 : m[h]) || 0) + (y ? 0 : w.crossAxis), O = i.reference[h] + i.reference[$] + (y ? 0 : ((v = a.offset) == null ? void 0 : v[h]) || 0) - (y ? w.crossAxis : 0);
        g < T ? g = T : g > O && (g = O);
      }
      return {
        [b]: u,
        [h]: g
      };
    }
  };
}, ic = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: a = () => {
        },
        ...l
      } = Oe(e, t), s = await gt(t, l), c = Me(n), d = at(n), h = lt(n) === "y", {
        width: b,
        height: u
      } = r.floating;
      let g, f;
      c === "top" || c === "bottom" ? (g = c, f = d === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = c, g = d === "end" ? "top" : "bottom");
      const w = u - s[g], m = b - s[f], v = !t.middlewareData.shift;
      let $ = w, y = m;
      if (h) {
        const O = b - s.left - s.right;
        y = d || v ? Fe(m, O) : O;
      } else {
        const O = u - s.top - s.bottom;
        $ = d || v ? Fe(w, O) : O;
      }
      if (v && !d) {
        const O = ve(s.left, 0), A = ve(s.right, 0), p = ve(s.top, 0), I = ve(s.bottom, 0);
        h ? y = b - 2 * (O !== 0 || A !== 0 ? O + A : ve(s.left, s.right)) : $ = u - 2 * (p !== 0 || I !== 0 ? p + I : ve(s.top, s.bottom));
      }
      await a({
        ...t,
        availableWidth: y,
        availableHeight: $
      });
      const T = await o.getDimensions(i.floating);
      return b !== T.width || u !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _e(e) {
  return ri(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ne(e) {
  var t;
  return (t = (ri(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ri(e) {
  return e instanceof Node || e instanceof me(e).Node;
}
function Ie(e) {
  return e instanceof Element || e instanceof me(e).Element;
}
function Te(e) {
  return e instanceof HTMLElement || e instanceof me(e).HTMLElement;
}
function Kr(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function xt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = we(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function ac(e) {
  return ["table", "td", "th"].includes(_e(e));
}
function lr(e) {
  const t = sr(), n = we(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function lc(e) {
  let t = nt(e);
  for (; Te(t) && !nn(t); ) {
    if (lr(t))
      return t;
    t = nt(t);
  }
  return null;
}
function sr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function nn(e) {
  return ["html", "body", "#document"].includes(_e(e));
}
function we(e) {
  return me(e).getComputedStyle(e);
}
function rn(e) {
  return Ie(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function nt(e) {
  if (_e(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Kr(e) && e.host || // Fallback.
    Ne(e)
  );
  return Kr(t) ? t.host : t;
}
function oi(e) {
  const t = nt(e);
  return nn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Te(t) && xt(t) ? t : oi(t);
}
function bt(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = oi(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = me(o);
  return i ? t.concat(a, a.visualViewport || [], xt(o) ? o : [], a.frameElement && n ? bt(a.frameElement) : []) : t.concat(o, bt(o, [], n));
}
function ii(e) {
  const t = we(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Te(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, l = zt(n) !== i || zt(r) !== a;
  return l && (n = i, r = a), {
    width: n,
    height: r,
    $: l
  };
}
function cr(e) {
  return Ie(e) ? e : e.contextElement;
}
function Je(e) {
  const t = cr(e);
  if (!Te(t))
    return Ve(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = ii(t);
  let a = (i ? zt(n.width) : n.width) / r, l = (i ? zt(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const sc = /* @__PURE__ */ Ve(0);
function ai(e) {
  const t = me(e);
  return !sr() || !t.visualViewport ? sc : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function cc(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function Be(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = cr(e);
  let a = Ve(1);
  t && (r ? Ie(r) && (a = Je(r)) : a = Je(e));
  const l = cc(i, n, r) ? ai(i) : Ve(0);
  let s = (o.left + l.x) / a.x, c = (o.top + l.y) / a.y, d = o.width / a.x, h = o.height / a.y;
  if (i) {
    const b = me(i), u = r && Ie(r) ? me(r) : r;
    let g = b, f = g.frameElement;
    for (; f && r && u !== g; ) {
      const w = Je(f), m = f.getBoundingClientRect(), v = we(f), $ = m.left + (f.clientLeft + parseFloat(v.paddingLeft)) * w.x, y = m.top + (f.clientTop + parseFloat(v.paddingTop)) * w.y;
      s *= w.x, c *= w.y, d *= w.x, h *= w.y, s += $, c += y, g = me(f), f = g.frameElement;
    }
  }
  return jt({
    width: d,
    height: h,
    x: s,
    y: c
  });
}
const dc = [":popover-open", ":modal"];
function li(e) {
  return dc.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function uc(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Ne(r), l = t ? li(t.floating) : !1;
  if (r === a || l && i)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ve(1);
  const d = Ve(0), h = Te(r);
  if ((h || !h && !i) && ((_e(r) !== "body" || xt(a)) && (s = rn(r)), Te(r))) {
    const b = Be(r);
    c = Je(r), d.x = b.x + r.clientLeft, d.y = b.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - s.scrollLeft * c.x + d.x,
    y: n.y * c.y - s.scrollTop * c.y + d.y
  };
}
function fc(e) {
  return Array.from(e.getClientRects());
}
function si(e) {
  return Be(Ne(e)).left + rn(e).scrollLeft;
}
function pc(e) {
  const t = Ne(e), n = rn(e), r = e.ownerDocument.body, o = ve(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = ve(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + si(e);
  const l = -n.scrollTop;
  return we(r).direction === "rtl" && (a += ve(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: l
  };
}
function vc(e, t) {
  const n = me(e), r = Ne(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = sr();
    (!c || c && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function mc(e, t) {
  const n = Be(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Te(e) ? Je(e) : Ve(1), a = e.clientWidth * i.x, l = e.clientHeight * i.y, s = o * i.x, c = r * i.y;
  return {
    width: a,
    height: l,
    x: s,
    y: c
  };
}
function Wr(e, t, n) {
  let r;
  if (t === "viewport")
    r = vc(e, n);
  else if (t === "document")
    r = pc(Ne(e));
  else if (Ie(t))
    r = mc(t, n);
  else {
    const o = ai(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return jt(r);
}
function ci(e, t) {
  const n = nt(e);
  return n === t || !Ie(n) || nn(n) ? !1 : we(n).position === "fixed" || ci(n, t);
}
function hc(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = bt(e, [], !1).filter((l) => Ie(l) && _e(l) !== "body"), o = null;
  const i = we(e).position === "fixed";
  let a = i ? nt(e) : e;
  for (; Ie(a) && !nn(a); ) {
    const l = we(a), s = lr(a);
    !s && l.position === "fixed" && (o = null), (i ? !s && !o : !s && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || xt(a) && !s && ci(e, a)) ? r = r.filter((d) => d !== a) : o = l, a = nt(a);
  }
  return t.set(e, r), r;
}
function gc(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? hc(t, this._c) : [].concat(n), r], l = a[0], s = a.reduce((c, d) => {
    const h = Wr(t, d, o);
    return c.top = ve(h.top, c.top), c.right = Fe(h.right, c.right), c.bottom = Fe(h.bottom, c.bottom), c.left = ve(h.left, c.left), c;
  }, Wr(t, l, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function bc(e) {
  const {
    width: t,
    height: n
  } = ii(e);
  return {
    width: t,
    height: n
  };
}
function wc(e, t, n) {
  const r = Te(t), o = Ne(t), i = n === "fixed", a = Be(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Ve(0);
  if (r || !r && !i)
    if ((_e(t) !== "body" || xt(o)) && (l = rn(t)), r) {
      const h = Be(t, !0, i, t);
      s.x = h.x + t.clientLeft, s.y = h.y + t.clientTop;
    } else
      o && (s.x = si(o));
  const c = a.left + l.scrollLeft - s.x, d = a.top + l.scrollTop - s.y;
  return {
    x: c,
    y: d,
    width: a.width,
    height: a.height
  };
}
function zr(e, t) {
  return !Te(e) || we(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function di(e, t) {
  const n = me(e);
  if (!Te(e) || li(e))
    return n;
  let r = zr(e, t);
  for (; r && ac(r) && we(r).position === "static"; )
    r = zr(r, t);
  return r && (_e(r) === "html" || _e(r) === "body" && we(r).position === "static" && !lr(r)) ? n : r || lc(e) || n;
}
const $c = async function(e) {
  const t = this.getOffsetParent || di, n = this.getDimensions;
  return {
    reference: wc(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await n(e.floating)
    }
  };
};
function yc(e) {
  return we(e).direction === "rtl";
}
const xc = {
  convertOffsetParentRelativeRectToViewportRelativeRect: uc,
  getDocumentElement: Ne,
  getClippingRect: gc,
  getOffsetParent: di,
  getElementRects: $c,
  getClientRects: fc,
  getDimensions: bc,
  getScale: Je,
  isElement: Ie,
  isRTL: yc
};
function Pc(e, t) {
  let n = null, r;
  const o = Ne(e);
  function i() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function a(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), i();
    const {
      left: c,
      top: d,
      width: h,
      height: b
    } = e.getBoundingClientRect();
    if (l || t(), !h || !b)
      return;
    const u = Ct(d), g = Ct(o.clientWidth - (c + h)), f = Ct(o.clientHeight - (d + b)), w = Ct(c), v = {
      rootMargin: -u + "px " + -g + "px " + -f + "px " + -w + "px",
      threshold: ve(0, Fe(1, s)) || 1
    };
    let $ = !0;
    function y(T) {
      const O = T[0].intersectionRatio;
      if (O !== s) {
        if (!$)
          return a();
        O ? a(!1, O) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      $ = !1;
    }
    try {
      n = new IntersectionObserver(y, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(y, v);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function Tc(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = r, c = cr(e), d = o || i ? [...c ? bt(c) : [], ...bt(t)] : [];
  d.forEach((m) => {
    o && m.addEventListener("scroll", n, {
      passive: !0
    }), i && m.addEventListener("resize", n);
  });
  const h = c && l ? Pc(c, n) : null;
  let b = -1, u = null;
  a && (u = new ResizeObserver((m) => {
    let [v] = m;
    v && v.target === c && u && (u.unobserve(t), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var $;
      ($ = u) == null || $.observe(t);
    })), n();
  }), c && !s && u.observe(c), u.observe(t));
  let g, f = s ? Be(e) : null;
  s && w();
  function w() {
    const m = Be(e);
    f && (m.x !== f.x || m.y !== f.y || m.width !== f.width || m.height !== f.height) && n(), f = m, g = requestAnimationFrame(w);
  }
  return n(), () => {
    var m;
    d.forEach((v) => {
      o && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), h == null || h(), (m = u) == null || m.disconnect(), u = null, s && cancelAnimationFrame(g);
  };
}
const Sc = rc, Ec = Js, Cc = ic, Dc = ec, Ur = Qs, Oc = oc, Mc = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: xc,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Zs(e, t, {
    ...o,
    platform: i
  });
}, Ic = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ur({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Ur({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var kt = typeof document < "u" ? Gt : H;
function Xt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Xt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Xt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ui(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function jr(e, t) {
  const n = ui(e);
  return Math.round(t * n) / n;
}
function Xr(e) {
  const t = L(e);
  return kt(() => {
    t.current = e;
  }), t;
}
function Ac(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: l = !0,
    whileElementsMounted: s,
    open: c
  } = e, [d, h] = F({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [b, u] = F(r);
  Xt(b, r) || u(r);
  const [g, f] = F(null), [w, m] = F(null), v = K((_) => {
    _ !== O.current && (O.current = _, f(_));
  }, []), $ = K((_) => {
    _ !== A.current && (A.current = _, m(_));
  }, []), y = i || g, T = a || w, O = L(null), A = L(null), p = L(d), I = s != null, R = Xr(s), E = Xr(o), k = K(() => {
    if (!O.current || !A.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: b
    };
    E.current && (_.platform = E.current), Mc(O.current, A.current, _).then((j) => {
      const q = {
        ...j,
        isPositioned: !0
      };
      x.current && !Xt(p.current, q) && (p.current = q, jn(() => {
        h(q);
      }));
    });
  }, [b, t, n, E]);
  kt(() => {
    c === !1 && p.current.isPositioned && (p.current.isPositioned = !1, h((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [c]);
  const x = L(!1);
  kt(() => (x.current = !0, () => {
    x.current = !1;
  }), []), kt(() => {
    if (y && (O.current = y), T && (A.current = T), y && T) {
      if (R.current)
        return R.current(y, T, k);
      k();
    }
  }, [y, T, k, R, I]);
  const P = Z(() => ({
    reference: O,
    floating: A,
    setReference: v,
    setFloating: $
  }), [v, $]), N = Z(() => ({
    reference: y,
    floating: T
  }), [y, T]), M = Z(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!N.floating)
      return _;
    const j = jr(N.floating, d.x), q = jr(N.floating, d.y);
    return l ? {
      ..._,
      transform: "translate(" + j + "px, " + q + "px)",
      ...ui(N.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: q
    };
  }, [n, l, N.floating, d.x, d.y]);
  return Z(() => ({
    ...d,
    update: k,
    refs: P,
    elements: N,
    floatingStyles: M
  }), [d, k, P, N, M]);
}
function Nc(e) {
  const [t, n] = F(void 0);
  return ue(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, l;
        if ("borderBoxSize" in i) {
          const s = i.borderBoxSize, c = Array.isArray(s) ? s[0] : s;
          a = c.inlineSize, l = c.blockSize;
        } else
          a = e.offsetWidth, l = e.offsetHeight;
        n({
          width: a,
          height: l
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const fi = "Popper", [pi, vi] = tn(fi), [Lc, mi] = pi(fi), kc = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = F(null);
  return /* @__PURE__ */ C(Lc, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, Rc = "PopperAnchor", Fc = /* @__PURE__ */ V((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, i = mi(Rc, n), a = L(null), l = re(t, a);
  return H(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ C(ne.div, W({}, o, {
    ref: l
  }));
}), hi = "PopperContent", [Vc, af] = pi(hi), _c = /* @__PURE__ */ V((e, t) => {
  var n, r, o, i, a, l, s, c;
  const { __scopePopper: d, side: h = "bottom", sideOffset: b = 0, align: u = "center", alignOffset: g = 0, arrowPadding: f = 0, avoidCollisions: w = !0, collisionBoundary: m = [], collisionPadding: v = 0, sticky: $ = "partial", hideWhenDetached: y = !1, updatePositionStrategy: T = "optimized", onPlaced: O, ...A } = e, p = mi(hi, d), [I, R] = F(null), E = re(
    t,
    (Se) => R(Se)
  ), [k, x] = F(null), P = Nc(k), N = (n = P == null ? void 0 : P.width) !== null && n !== void 0 ? n : 0, M = (r = P == null ? void 0 : P.height) !== null && r !== void 0 ? r : 0, _ = h + (u !== "center" ? "-" + u : ""), j = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, q = Array.isArray(m) ? m : [
    m
  ], $e = q.length > 0, D = {
    padding: j,
    boundary: q.filter(Hc),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: $e
  }, { refs: U, floatingStyles: J, placement: se, isPositioned: le, middlewareData: ce } = Ac({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: _,
    whileElementsMounted: (...Se) => Tc(...Se, {
      animationFrame: T === "always"
    }),
    elements: {
      reference: p.anchor
    },
    middleware: [
      nc({
        mainAxis: b + M,
        alignmentAxis: g
      }),
      w && Sc({
        mainAxis: !0,
        crossAxis: !1,
        limiter: $ === "partial" ? Oc() : void 0,
        ...D
      }),
      w && Ec({
        ...D
      }),
      Cc({
        ...D,
        apply: ({ elements: Se, rects: Ue, availableWidth: ct, availableHeight: la }) => {
          const { width: sa, height: ca } = Ue.reference, Pt = Se.floating.style;
          Pt.setProperty("--radix-popper-available-width", `${ct}px`), Pt.setProperty("--radix-popper-available-height", `${la}px`), Pt.setProperty("--radix-popper-anchor-width", `${sa}px`), Pt.setProperty("--radix-popper-anchor-height", `${ca}px`);
        }
      }),
      k && Ic({
        element: k,
        padding: f
      }),
      Bc({
        arrowWidth: N,
        arrowHeight: M
      }),
      y && Dc({
        strategy: "referenceHidden",
        ...D
      })
    ]
  }), [B, X] = gi(se), te = De(O);
  ue(() => {
    le && (te == null || te());
  }, [
    le,
    te
  ]);
  const Q = (o = ce.arrow) === null || o === void 0 ? void 0 : o.x, Y = (i = ce.arrow) === null || i === void 0 ? void 0 : i.y, G = ((a = ce.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [fe, pe] = F();
  return ue(() => {
    I && pe(window.getComputedStyle(I).zIndex);
  }, [
    I
  ]), /* @__PURE__ */ C("div", {
    ref: U.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...J,
      transform: le ? J.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: fe,
      "--radix-popper-transform-origin": [
        (l = ce.transformOrigin) === null || l === void 0 ? void 0 : l.x,
        (s = ce.transformOrigin) === null || s === void 0 ? void 0 : s.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ C(Vc, {
    scope: d,
    placedSide: B,
    onArrowChange: x,
    arrowX: Q,
    arrowY: Y,
    shouldHideArrow: G
  }, /* @__PURE__ */ C(ne.div, W({
    "data-side": B,
    "data-align": X
  }, A, {
    ref: E,
    style: {
      ...A.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: le ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = ce.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function Hc(e) {
  return e !== null;
}
const Bc = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, i, a;
    const { placement: l, rects: s, middlewareData: c } = t, h = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, b = h ? 0 : e.arrowWidth, u = h ? 0 : e.arrowHeight, [g, f] = gi(l), w = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], m = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + b / 2, v = ((i = (a = c.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + u / 2;
    let $ = "", y = "";
    return g === "bottom" ? ($ = h ? w : `${m}px`, y = `${-u}px`) : g === "top" ? ($ = h ? w : `${m}px`, y = `${s.floating.height + u}px`) : g === "right" ? ($ = `${-u}px`, y = h ? w : `${v}px`) : g === "left" && ($ = `${s.floating.width + u}px`, y = h ? w : `${v}px`), {
      data: {
        x: $,
        y
      }
    };
  }
});
function gi(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Kc = kc, Wc = Fc, zc = _c, bi = /* @__PURE__ */ V((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ z.createPortal(/* @__PURE__ */ C(ne.div, W({}, o, {
    ref: t
  })), r) : null;
});
function Bn({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Uc({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, l = De(n), s = K((c) => {
    if (i) {
      const h = typeof c == "function" ? c(e) : c;
      h !== e && l(h);
    } else
      o(c);
  }, [
    i,
    e,
    o,
    l
  ]);
  return [
    a,
    s
  ];
}
function Uc({ defaultProp: e, onChange: t }) {
  const n = F(e), [r] = n, o = L(r), i = De(t);
  return H(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function jc(e) {
  const t = L({
    value: e,
    previous: e
  });
  return Z(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Xc = /* @__PURE__ */ V((e, t) => /* @__PURE__ */ C(ne.span, W({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
})));
var Yc = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Xe = /* @__PURE__ */ new WeakMap(), Dt = /* @__PURE__ */ new WeakMap(), Ot = {}, wn = 0, wi = function(e) {
  return e && (e.host || wi(e.parentNode));
}, Gc = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = wi(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, qc = function(e, t, n, r) {
  var o = Gc(t, Array.isArray(e) ? e : [e]);
  Ot[n] || (Ot[n] = /* @__PURE__ */ new WeakMap());
  var i = Ot[n], a = [], l = /* @__PURE__ */ new Set(), s = new Set(o), c = function(h) {
    !h || l.has(h) || (l.add(h), c(h.parentNode));
  };
  o.forEach(c);
  var d = function(h) {
    !h || s.has(h) || Array.prototype.forEach.call(h.children, function(b) {
      if (l.has(b))
        d(b);
      else
        try {
          var u = b.getAttribute(r), g = u !== null && u !== "false", f = (Xe.get(b) || 0) + 1, w = (i.get(b) || 0) + 1;
          Xe.set(b, f), i.set(b, w), a.push(b), f === 1 && g && Dt.set(b, !0), w === 1 && b.setAttribute(n, "true"), g || b.setAttribute(r, "true");
        } catch (m) {
          console.error("aria-hidden: cannot operate on ", b, m);
        }
    });
  };
  return d(t), l.clear(), wn++, function() {
    a.forEach(function(h) {
      var b = Xe.get(h) - 1, u = i.get(h) - 1;
      Xe.set(h, b), i.set(h, u), b || (Dt.has(h) || h.removeAttribute(r), Dt.delete(h)), u || h.removeAttribute(n);
    }), wn--, wn || (Xe = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), Dt = /* @__PURE__ */ new WeakMap(), Ot = {});
  };
}, $i = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || Yc(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), qc(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Rt = "right-scroll-bar-position", Ft = "width-before-scroll-bar", Zc = "with-scroll-bars-hidden", Qc = "--removed-body-scroll-bar-size";
function $n(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Jc(e, t) {
  var n = F(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var ed = typeof window < "u" ? Gt : H, Yr = /* @__PURE__ */ new WeakMap();
function td(e, t) {
  var n = Jc(t || null, function(r) {
    return e.forEach(function(o) {
      return $n(o, r);
    });
  });
  return ed(function() {
    var r = Yr.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(l) {
        i.has(l) || $n(l, null);
      }), i.forEach(function(l) {
        o.has(l) || $n(l, a);
      });
    }
    Yr.set(n, e);
  }, [e]), n;
}
function nd(e) {
  return e;
}
function rd(e, t) {
  t === void 0 && (t = nd);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(l) {
          return l !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(l) {
          return i(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(i), a = n;
      }
      var s = function() {
        var d = a;
        a = [], d.forEach(i);
      }, c = function() {
        return Promise.resolve().then(s);
      };
      c(), n = {
        push: function(d) {
          a.push(d), c();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return o;
}
function od(e) {
  e === void 0 && (e = {});
  var t = rd(null);
  return t.options = xe({ async: !0, ssr: !1 }, e), t;
}
var yi = function(e) {
  var t = e.sideCar, n = Vo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return C(r, xe({}, n));
};
yi.isSideCarExport = !0;
function id(e, t) {
  return e.useMedium(t), yi;
}
var xi = od(), yn = function() {
}, on = V(function(e, t) {
  var n = L(null), r = F({
    onScrollCapture: yn,
    onWheelCapture: yn,
    onTouchMoveCapture: yn
  }), o = r[0], i = r[1], a = e.forwardProps, l = e.children, s = e.className, c = e.removeScrollBar, d = e.enabled, h = e.shards, b = e.sideCar, u = e.noIsolation, g = e.inert, f = e.allowPinchZoom, w = e.as, m = w === void 0 ? "div" : w, v = Vo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), $ = b, y = td([n, t]), T = xe(xe({}, v), o);
  return C(
    Ae,
    null,
    d && C($, { sideCar: xi, removeScrollBar: c, shards: h, noIsolation: u, inert: g, setCallbacks: i, allowPinchZoom: !!f, lockRef: n }),
    a ? Yt(Re.only(l), xe(xe({}, T), { ref: y })) : C(m, xe({}, T, { className: s, ref: y }), l)
  );
});
on.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
on.classNames = {
  fullWidth: Ft,
  zeroRight: Rt
};
var ad = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ld() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ad();
  return t && e.setAttribute("nonce", t), e;
}
function sd(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function cd(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var dd = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = ld()) && (sd(t, n), cd(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ud = function() {
  var e = dd();
  return function(t, n) {
    H(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Pi = function() {
  var e = ud(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, fd = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, xn = function(e) {
  return parseInt(e || "", 10) || 0;
}, pd = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [xn(n), xn(r), xn(o)];
}, vd = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return fd;
  var t = pd(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, md = Pi(), et = "data-scroll-locked", hd = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Zc, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body[`).concat(et, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Rt, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(Ft, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(Rt, " .").concat(Rt, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ft, " .").concat(Ft, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(et, `] {
    `).concat(Qc, ": ").concat(l, `px;
  }
`);
}, Gr = function() {
  var e = parseInt(document.body.getAttribute(et) || "0", 10);
  return isFinite(e) ? e : 0;
}, gd = function() {
  H(function() {
    return document.body.setAttribute(et, (Gr() + 1).toString()), function() {
      var e = Gr() - 1;
      e <= 0 ? document.body.removeAttribute(et) : document.body.setAttribute(et, e.toString());
    };
  }, []);
}, bd = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  gd();
  var i = Z(function() {
    return vd(o);
  }, [o]);
  return C(md, { styles: hd(i, !t, o, n ? "" : "!important") });
}, Kn = !1;
if (typeof window < "u")
  try {
    var Mt = Object.defineProperty({}, "passive", {
      get: function() {
        return Kn = !0, !0;
      }
    });
    window.addEventListener("test", Mt, Mt), window.removeEventListener("test", Mt, Mt);
  } catch {
    Kn = !1;
  }
var Ye = Kn ? { passive: !1 } : !1, wd = function(e) {
  return e.tagName === "TEXTAREA";
}, Ti = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !wd(e) && n[t] === "visible")
  );
}, $d = function(e) {
  return Ti(e, "overflowY");
}, yd = function(e) {
  return Ti(e, "overflowX");
}, qr = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Si(e, n);
    if (r) {
      var o = Ei(e, n), i = o[1], a = o[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, xd = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Pd = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Si = function(e, t) {
  return e === "v" ? $d(t) : yd(t);
}, Ei = function(e, t) {
  return e === "v" ? xd(t) : Pd(t);
}, Td = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Sd = function(e, t, n, r, o) {
  var i = Td(e, window.getComputedStyle(t).direction), a = i * r, l = n.target, s = t.contains(l), c = !1, d = a > 0, h = 0, b = 0;
  do {
    var u = Ei(e, l), g = u[0], f = u[1], w = u[2], m = f - w - i * g;
    (g || m) && Si(e, l) && (h += m, b += g), l = l.parentNode;
  } while (
    // portaled content
    !s && l !== document.body || // self content
    s && (t.contains(l) || t === l)
  );
  return (d && (o && h === 0 || !o && a > h) || !d && (o && b === 0 || !o && -a > b)) && (c = !0), c;
}, It = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Zr = function(e) {
  return [e.deltaX, e.deltaY];
}, Qr = function(e) {
  return e && "current" in e ? e.current : e;
}, Ed = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Cd = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Dd = 0, Ge = [];
function Od(e) {
  var t = L([]), n = L([0, 0]), r = L(), o = F(Dd++)[0], i = F(function() {
    return Pi();
  })[0], a = L(e);
  H(function() {
    a.current = e;
  }, [e]), H(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var f = Ol([e.lockRef.current], (e.shards || []).map(Qr), !0).filter(Boolean);
      return f.forEach(function(w) {
        return w.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), f.forEach(function(w) {
          return w.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = K(function(f, w) {
    if ("touches" in f && f.touches.length === 2)
      return !a.current.allowPinchZoom;
    var m = It(f), v = n.current, $ = "deltaX" in f ? f.deltaX : v[0] - m[0], y = "deltaY" in f ? f.deltaY : v[1] - m[1], T, O = f.target, A = Math.abs($) > Math.abs(y) ? "h" : "v";
    if ("touches" in f && A === "h" && O.type === "range")
      return !1;
    var p = qr(A, O);
    if (!p)
      return !0;
    if (p ? T = A : (T = A === "v" ? "h" : "v", p = qr(A, O)), !p)
      return !1;
    if (!r.current && "changedTouches" in f && ($ || y) && (r.current = T), !T)
      return !0;
    var I = r.current || T;
    return Sd(I, w, f, I === "h" ? $ : y, !0);
  }, []), s = K(function(f) {
    var w = f;
    if (!(!Ge.length || Ge[Ge.length - 1] !== i)) {
      var m = "deltaY" in w ? Zr(w) : It(w), v = t.current.filter(function(T) {
        return T.name === w.type && T.target === w.target && Ed(T.delta, m);
      })[0];
      if (v && v.should) {
        w.cancelable && w.preventDefault();
        return;
      }
      if (!v) {
        var $ = (a.current.shards || []).map(Qr).filter(Boolean).filter(function(T) {
          return T.contains(w.target);
        }), y = $.length > 0 ? l(w, $[0]) : !a.current.noIsolation;
        y && w.cancelable && w.preventDefault();
      }
    }
  }, []), c = K(function(f, w, m, v) {
    var $ = { name: f, delta: w, target: m, should: v };
    t.current.push($), setTimeout(function() {
      t.current = t.current.filter(function(y) {
        return y !== $;
      });
    }, 1);
  }, []), d = K(function(f) {
    n.current = It(f), r.current = void 0;
  }, []), h = K(function(f) {
    c(f.type, Zr(f), f.target, l(f, e.lockRef.current));
  }, []), b = K(function(f) {
    c(f.type, It(f), f.target, l(f, e.lockRef.current));
  }, []);
  H(function() {
    return Ge.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", s, Ye), document.addEventListener("touchmove", s, Ye), document.addEventListener("touchstart", d, Ye), function() {
      Ge = Ge.filter(function(f) {
        return f !== i;
      }), document.removeEventListener("wheel", s, Ye), document.removeEventListener("touchmove", s, Ye), document.removeEventListener("touchstart", d, Ye);
    };
  }, []);
  var u = e.removeScrollBar, g = e.inert;
  return C(
    Ae,
    null,
    g ? C(i, { styles: Cd(o) }) : null,
    u ? C(bd, { gapMode: "margin" }) : null
  );
}
const Md = id(xi, Od);
var Ci = V(function(e, t) {
  return C(on, xe({}, e, { ref: t, sideCar: Md }));
});
Ci.classNames = on.classNames;
const Di = Ci, Id = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], Ad = [
  " ",
  "Enter"
], an = "Select", [ln, sn, Nd] = Ts(an), [st, lf] = tn(an, [
  Nd,
  vi
]), dr = vi(), [Ld, We] = st(an), [kd, Rd] = st(an), Fd = (e) => {
  const { __scopeSelect: t, children: n, open: r, defaultOpen: o, onOpenChange: i, value: a, defaultValue: l, onValueChange: s, dir: c, name: d, autoComplete: h, disabled: b, required: u } = e, g = dr(t), [f, w] = F(null), [m, v] = F(null), [$, y] = F(!1), T = Es(c), [O = !1, A] = Bn({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [p, I] = Bn({
    prop: a,
    defaultProp: l,
    onChange: s
  }), R = L(null), E = f ? !!f.closest("form") : !0, [k, x] = F(/* @__PURE__ */ new Set()), P = Array.from(k).map(
    (N) => N.props.value
  ).join(";");
  return /* @__PURE__ */ C(Kc, g, /* @__PURE__ */ C(Ld, {
    required: u,
    scope: t,
    trigger: f,
    onTriggerChange: w,
    valueNode: m,
    onValueNodeChange: v,
    valueNodeHasChildren: $,
    onValueNodeHasChildrenChange: y,
    contentId: vt(),
    value: p,
    onValueChange: I,
    open: O,
    onOpenChange: A,
    dir: T,
    triggerPointerDownPosRef: R,
    disabled: b
  }, /* @__PURE__ */ C(ln.Provider, {
    scope: t
  }, /* @__PURE__ */ C(kd, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: K((N) => {
      x(
        (M) => new Set(M).add(N)
      );
    }, []),
    onNativeOptionRemove: K((N) => {
      x((M) => {
        const _ = new Set(M);
        return _.delete(N), _;
      });
    }, [])
  }, n)), E ? /* @__PURE__ */ C(Ni, {
    key: P,
    "aria-hidden": !0,
    required: u,
    tabIndex: -1,
    name: d,
    autoComplete: h,
    value: p,
    onChange: (N) => I(N.target.value),
    disabled: b
  }, p === void 0 ? /* @__PURE__ */ C("option", {
    value: ""
  }) : null, Array.from(k)) : null));
}, Vd = "SelectTrigger", _d = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = dr(n), a = We(Vd, n), l = a.disabled || r, s = re(t, a.onTriggerChange), c = sn(n), [d, h, b] = Li((g) => {
    const f = c().filter(
      (v) => !v.disabled
    ), w = f.find(
      (v) => v.value === a.value
    ), m = ki(f, g, w);
    m !== void 0 && a.onValueChange(m.value);
  }), u = () => {
    l || (a.onOpenChange(!0), b());
  };
  return /* @__PURE__ */ C(Wc, W({
    asChild: !0
  }, i), /* @__PURE__ */ C(ne.button, W({
    type: "button",
    role: "combobox",
    "aria-controls": a.contentId,
    "aria-expanded": a.open,
    "aria-required": a.required,
    "aria-autocomplete": "none",
    dir: a.dir,
    "data-state": a.open ? "open" : "closed",
    disabled: l,
    "data-disabled": l ? "" : void 0,
    "data-placeholder": Ai(a.value) ? "" : void 0
  }, o, {
    ref: s,
    onClick: ee(o.onClick, (g) => {
      g.currentTarget.focus();
    }),
    onPointerDown: ee(o.onPointerDown, (g) => {
      const f = g.target;
      f.hasPointerCapture(g.pointerId) && f.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && (u(), a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      }, g.preventDefault());
    }),
    onKeyDown: ee(o.onKeyDown, (g) => {
      const f = d.current !== "";
      !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && h(g.key), !(f && g.key === " ") && Id.includes(g.key) && (u(), g.preventDefault());
    })
  })));
}), Hd = "SelectValue", Bd = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...l } = e, s = We(Hd, n), { onValueNodeHasChildrenChange: c } = s, d = i !== void 0, h = re(t, s.onValueNodeChange);
  return ue(() => {
    c(d);
  }, [
    c,
    d
  ]), /* @__PURE__ */ C(ne.span, W({}, l, {
    ref: h,
    style: {
      pointerEvents: "none"
    }
  }), Ai(s.value) ? /* @__PURE__ */ C(Ae, null, a) : i);
}), Kd = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, children: r, ...o } = e;
  return /* @__PURE__ */ C(ne.span, W({
    "aria-hidden": !0
  }, o, {
    ref: t
  }), r || "▼");
}), Wd = (e) => /* @__PURE__ */ C(bi, W({
  asChild: !0
}, e)), rt = "SelectContent", zd = /* @__PURE__ */ V((e, t) => {
  const n = We(rt, e.__scopeSelect), [r, o] = F();
  if (ue(() => {
    o(new DocumentFragment());
  }, []), !n.open) {
    const i = r;
    return i ? /* @__PURE__ */ ao(/* @__PURE__ */ C(Oi, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ C(ln.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ C("div", null, e.children))), i) : null;
  }
  return /* @__PURE__ */ C(Ud, W({}, e, {
    ref: t
  }));
}), Ce = 10, [Oi, ze] = st(rt), Ud = /* @__PURE__ */ V((e, t) => {
  const {
    __scopeSelect: n,
    position: r = "item-aligned",
    onCloseAutoFocus: o,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    side: l,
    sideOffset: s,
    align: c,
    alignOffset: d,
    arrowPadding: h,
    collisionBoundary: b,
    collisionPadding: u,
    sticky: g,
    hideWhenDetached: f,
    avoidCollisions: w,
    //
    ...m
  } = e, v = We(rt, n), [$, y] = F(null), [T, O] = F(null), A = re(
    t,
    (B) => y(B)
  ), [p, I] = F(null), [R, E] = F(null), k = sn(n), [x, P] = F(!1), N = L(!1);
  H(() => {
    if ($)
      return $i($);
  }, [
    $
  ]), Jo();
  const M = K((B) => {
    const [X, ...te] = k().map(
      (G) => G.ref.current
    ), [Q] = te.slice(-1), Y = document.activeElement;
    for (const G of B)
      if (G === Y || (G == null || G.scrollIntoView({
        block: "nearest"
      }), G === X && T && (T.scrollTop = 0), G === Q && T && (T.scrollTop = T.scrollHeight), G == null || G.focus(), document.activeElement !== Y))
        return;
  }, [
    k,
    T
  ]), _ = K(
    () => M([
      p,
      $
    ]),
    [
      M,
      p,
      $
    ]
  );
  H(() => {
    x && _();
  }, [
    x,
    _
  ]);
  const { onOpenChange: j, triggerPointerDownPosRef: q } = v;
  H(() => {
    if ($) {
      let B = {
        x: 0,
        y: 0
      };
      const X = (Q) => {
        var Y, G, fe, pe;
        B = {
          x: Math.abs(Math.round(Q.pageX) - ((Y = (G = q.current) === null || G === void 0 ? void 0 : G.x) !== null && Y !== void 0 ? Y : 0)),
          y: Math.abs(Math.round(Q.pageY) - ((fe = (pe = q.current) === null || pe === void 0 ? void 0 : pe.y) !== null && fe !== void 0 ? fe : 0))
        };
      }, te = (Q) => {
        B.x <= 10 && B.y <= 10 ? Q.preventDefault() : $.contains(Q.target) || j(!1), document.removeEventListener("pointermove", X), q.current = null;
      };
      return q.current !== null && (document.addEventListener("pointermove", X), document.addEventListener("pointerup", te, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", X), document.removeEventListener("pointerup", te, {
          capture: !0
        });
      };
    }
  }, [
    $,
    j,
    q
  ]), H(() => {
    const B = () => j(!1);
    return window.addEventListener("blur", B), window.addEventListener("resize", B), () => {
      window.removeEventListener("blur", B), window.removeEventListener("resize", B);
    };
  }, [
    j
  ]);
  const [$e, D] = Li((B) => {
    const X = k().filter(
      (Y) => !Y.disabled
    ), te = X.find(
      (Y) => Y.ref.current === document.activeElement
    ), Q = ki(X, B, te);
    Q && setTimeout(
      () => Q.ref.current.focus()
    );
  }), U = K((B, X, te) => {
    const Q = !N.current && !te;
    (v.value !== void 0 && v.value === X || Q) && (I(B), Q && (N.current = !0));
  }, [
    v.value
  ]), J = K(
    () => $ == null ? void 0 : $.focus(),
    [
      $
    ]
  ), se = K((B, X, te) => {
    const Q = !N.current && !te;
    (v.value !== void 0 && v.value === X || Q) && E(B);
  }, [
    v.value
  ]), le = r === "popper" ? Jr : jd, ce = le === Jr ? {
    side: l,
    sideOffset: s,
    align: c,
    alignOffset: d,
    arrowPadding: h,
    collisionBoundary: b,
    collisionPadding: u,
    sticky: g,
    hideWhenDetached: f,
    avoidCollisions: w
  } : {};
  return /* @__PURE__ */ C(Oi, {
    scope: n,
    content: $,
    viewport: T,
    onViewportChange: O,
    itemRefCallback: U,
    selectedItem: p,
    onItemLeave: J,
    itemTextRefCallback: se,
    focusSelectedItem: _,
    selectedItemText: R,
    position: r,
    isPositioned: x,
    searchRef: $e
  }, /* @__PURE__ */ C(Di, {
    as: tt,
    allowPinchZoom: !0
  }, /* @__PURE__ */ C(ei, {
    asChild: !0,
    trapped: v.open,
    onMountAutoFocus: (B) => {
      B.preventDefault();
    },
    onUnmountAutoFocus: ee(o, (B) => {
      var X;
      (X = v.trigger) === null || X === void 0 || X.focus({
        preventScroll: !0
      }), B.preventDefault();
    })
  }, /* @__PURE__ */ C(Zo, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    onFocusOutside: (B) => B.preventDefault(),
    onDismiss: () => v.onOpenChange(!1)
  }, /* @__PURE__ */ C(le, W({
    role: "listbox",
    id: v.contentId,
    "data-state": v.open ? "open" : "closed",
    dir: v.dir,
    onContextMenu: (B) => B.preventDefault()
  }, m, ce, {
    onPlaced: () => P(!0),
    ref: A,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...m.style
    },
    onKeyDown: ee(m.onKeyDown, (B) => {
      const X = B.ctrlKey || B.altKey || B.metaKey;
      if (B.key === "Tab" && B.preventDefault(), !X && B.key.length === 1 && D(B.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(B.key)) {
        let Q = k().filter(
          (Y) => !Y.disabled
        ).map(
          (Y) => Y.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(B.key) && (Q = Q.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(B.key)) {
          const Y = B.target, G = Q.indexOf(Y);
          Q = Q.slice(G + 1);
        }
        setTimeout(
          () => M(Q)
        ), B.preventDefault();
      }
    })
  }))))));
}), jd = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = We(rt, n), a = ze(rt, n), [l, s] = F(null), [c, d] = F(null), h = re(
    t,
    (A) => d(A)
  ), b = sn(n), u = L(!1), g = L(!0), { viewport: f, selectedItem: w, selectedItemText: m, focusSelectedItem: v } = a, $ = K(() => {
    if (i.trigger && i.valueNode && l && c && f && w && m) {
      const A = i.trigger.getBoundingClientRect(), p = c.getBoundingClientRect(), I = i.valueNode.getBoundingClientRect(), R = m.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const Y = R.left - p.left, G = I.left - Y, fe = A.left - G, pe = A.width + fe, Se = Math.max(pe, p.width), Ue = window.innerWidth - Ce, ct = Ir(G, [
          Ce,
          Ue - Se
        ]);
        l.style.minWidth = pe + "px", l.style.left = ct + "px";
      } else {
        const Y = p.right - R.right, G = window.innerWidth - I.right - Y, fe = window.innerWidth - A.right - G, pe = A.width + fe, Se = Math.max(pe, p.width), Ue = window.innerWidth - Ce, ct = Ir(G, [
          Ce,
          Ue - Se
        ]);
        l.style.minWidth = pe + "px", l.style.right = ct + "px";
      }
      const E = b(), k = window.innerHeight - Ce * 2, x = f.scrollHeight, P = window.getComputedStyle(c), N = parseInt(P.borderTopWidth, 10), M = parseInt(P.paddingTop, 10), _ = parseInt(P.borderBottomWidth, 10), j = parseInt(P.paddingBottom, 10), q = N + M + x + j + _, $e = Math.min(w.offsetHeight * 5, q), D = window.getComputedStyle(f), U = parseInt(D.paddingTop, 10), J = parseInt(D.paddingBottom, 10), se = A.top + A.height / 2 - Ce, le = k - se, ce = w.offsetHeight / 2, B = w.offsetTop + ce, X = N + M + B, te = q - X;
      if (X <= se) {
        const Y = w === E[E.length - 1].ref.current;
        l.style.bottom = "0px";
        const G = c.clientHeight - f.offsetTop - f.offsetHeight, fe = Math.max(le, ce + (Y ? J : 0) + G + _), pe = X + fe;
        l.style.height = pe + "px";
      } else {
        const Y = w === E[0].ref.current;
        l.style.top = "0px";
        const fe = Math.max(se, N + f.offsetTop + (Y ? U : 0) + ce) + te;
        l.style.height = fe + "px", f.scrollTop = X - se + f.offsetTop;
      }
      l.style.margin = `${Ce}px 0`, l.style.minHeight = $e + "px", l.style.maxHeight = k + "px", r == null || r(), requestAnimationFrame(
        () => u.current = !0
      );
    }
  }, [
    b,
    i.trigger,
    i.valueNode,
    l,
    c,
    f,
    w,
    m,
    i.dir,
    r
  ]);
  ue(
    () => $(),
    [
      $
    ]
  );
  const [y, T] = F();
  ue(() => {
    c && T(window.getComputedStyle(c).zIndex);
  }, [
    c
  ]);
  const O = K((A) => {
    A && g.current === !0 && ($(), v == null || v(), g.current = !1);
  }, [
    $,
    v
  ]);
  return /* @__PURE__ */ C(Xd, {
    scope: n,
    contentWrapper: l,
    shouldExpandOnScrollRef: u,
    onScrollButtonChange: O
  }, /* @__PURE__ */ C("div", {
    ref: s,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: y
    }
  }, /* @__PURE__ */ C(ne.div, W({}, o, {
    ref: h,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...o.style
    }
  }))));
}), Jr = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, align: r = "start", collisionPadding: o = Ce, ...i } = e, a = dr(n);
  return /* @__PURE__ */ C(zc, W({}, a, i, {
    ref: t,
    align: r,
    collisionPadding: o,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...i.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [Xd, ur] = st(rt, {}), eo = "SelectViewport", Yd = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = ze(eo, n), i = ur(eo, n), a = re(t, o.onViewportChange), l = L(0);
  return /* @__PURE__ */ C(Ae, null, /* @__PURE__ */ C("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ C(ln.Slot, {
    scope: n
  }, /* @__PURE__ */ C(ne.div, W({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, r, {
    ref: a,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...r.style
    },
    onScroll: ee(r.onScroll, (s) => {
      const c = s.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: h } = i;
      if (h != null && h.current && d) {
        const b = Math.abs(l.current - c.scrollTop);
        if (b > 0) {
          const u = window.innerHeight - Ce * 2, g = parseFloat(d.style.minHeight), f = parseFloat(d.style.height), w = Math.max(g, f);
          if (w < u) {
            const m = w + b, v = Math.min(u, m), $ = m - v;
            d.style.height = v + "px", d.style.bottom === "0px" && (c.scrollTop = $ > 0 ? $ : 0, d.style.justifyContent = "flex-end");
          }
        }
      }
      l.current = c.scrollTop;
    })
  }))));
}), Gd = "SelectGroup", [sf, qd] = st(Gd), Zd = "SelectLabel", Qd = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = qd(Zd, n);
  return /* @__PURE__ */ C(ne.div, W({
    id: o.id
  }, r, {
    ref: t
  }));
}), Wn = "SelectItem", [Jd, Mi] = st(Wn), eu = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, value: r, disabled: o = !1, textValue: i, ...a } = e, l = We(Wn, n), s = ze(Wn, n), c = l.value === r, [d, h] = F(i ?? ""), [b, u] = F(!1), g = re(t, (m) => {
    var v;
    return (v = s.itemRefCallback) === null || v === void 0 ? void 0 : v.call(s, m, r, o);
  }), f = vt(), w = () => {
    o || (l.onValueChange(r), l.onOpenChange(!1));
  };
  if (r === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ C(Jd, {
    scope: n,
    value: r,
    disabled: o,
    textId: f,
    isSelected: c,
    onItemTextChange: K((m) => {
      h((v) => {
        var $;
        return v || (($ = m == null ? void 0 : m.textContent) !== null && $ !== void 0 ? $ : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ C(ln.ItemSlot, {
    scope: n,
    value: r,
    disabled: o,
    textValue: d
  }, /* @__PURE__ */ C(ne.div, W({
    role: "option",
    "aria-labelledby": f,
    "data-highlighted": b ? "" : void 0,
    "aria-selected": c && b,
    "data-state": c ? "checked" : "unchecked",
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0,
    tabIndex: o ? void 0 : -1
  }, a, {
    ref: g,
    onFocus: ee(
      a.onFocus,
      () => u(!0)
    ),
    onBlur: ee(
      a.onBlur,
      () => u(!1)
    ),
    onPointerUp: ee(a.onPointerUp, w),
    onPointerMove: ee(a.onPointerMove, (m) => {
      if (o) {
        var v;
        (v = s.onItemLeave) === null || v === void 0 || v.call(s);
      } else
        m.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: ee(a.onPointerLeave, (m) => {
      if (m.currentTarget === document.activeElement) {
        var v;
        (v = s.onItemLeave) === null || v === void 0 || v.call(s);
      }
    }),
    onKeyDown: ee(a.onKeyDown, (m) => {
      var v;
      ((v = s.searchRef) === null || v === void 0 ? void 0 : v.current) !== "" && m.key === " " || (Ad.includes(m.key) && w(), m.key === " " && m.preventDefault());
    })
  }))));
}), At = "SelectItemText", tu = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, className: r, style: o, ...i } = e, a = We(At, n), l = ze(At, n), s = Mi(At, n), c = Rd(At, n), [d, h] = F(null), b = re(
    t,
    (m) => h(m),
    s.onItemTextChange,
    (m) => {
      var v;
      return (v = l.itemTextRefCallback) === null || v === void 0 ? void 0 : v.call(l, m, s.value, s.disabled);
    }
  ), u = d == null ? void 0 : d.textContent, g = Z(
    () => /* @__PURE__ */ C("option", {
      key: s.value,
      value: s.value,
      disabled: s.disabled
    }, u),
    [
      s.disabled,
      s.value,
      u
    ]
  ), { onNativeOptionAdd: f, onNativeOptionRemove: w } = c;
  return ue(() => (f(g), () => w(g)), [
    f,
    w,
    g
  ]), /* @__PURE__ */ C(Ae, null, /* @__PURE__ */ C(ne.span, W({
    id: s.textId
  }, i, {
    ref: b
  })), s.isSelected && a.valueNode && !a.valueNodeHasChildren ? /* @__PURE__ */ ao(i.children, a.valueNode) : null);
}), nu = "SelectItemIndicator", ru = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, ...r } = e;
  return Mi(nu, n).isSelected ? /* @__PURE__ */ C(ne.span, W({
    "aria-hidden": !0
  }, r, {
    ref: t
  })) : null;
}), to = "SelectScrollUpButton", ou = /* @__PURE__ */ V((e, t) => {
  const n = ze(to, e.__scopeSelect), r = ur(to, e.__scopeSelect), [o, i] = F(!1), a = re(t, r.onScrollButtonChange);
  return ue(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), o ? /* @__PURE__ */ C(Ii, W({}, e, {
    ref: a,
    onAutoScroll: () => {
      const { viewport: l, selectedItem: s } = n;
      l && s && (l.scrollTop = l.scrollTop - s.offsetHeight);
    }
  })) : null;
}), no = "SelectScrollDownButton", iu = /* @__PURE__ */ V((e, t) => {
  const n = ze(no, e.__scopeSelect), r = ur(no, e.__scopeSelect), [o, i] = F(!1), a = re(t, r.onScrollButtonChange);
  return ue(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < c;
        i(d);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), o ? /* @__PURE__ */ C(Ii, W({}, e, {
    ref: a,
    onAutoScroll: () => {
      const { viewport: l, selectedItem: s } = n;
      l && s && (l.scrollTop = l.scrollTop + s.offsetHeight);
    }
  })) : null;
}), Ii = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = ze("SelectScrollButton", n), a = L(null), l = sn(n), s = K(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return H(() => () => s(), [
    s
  ]), ue(() => {
    var c;
    const d = l().find(
      (h) => h.ref.current === document.activeElement
    );
    d == null || (c = d.ref.current) === null || c === void 0 || c.scrollIntoView({
      block: "nearest"
    });
  }, [
    l
  ]), /* @__PURE__ */ C(ne.div, W({
    "aria-hidden": !0
  }, o, {
    ref: t,
    style: {
      flexShrink: 0,
      ...o.style
    },
    onPointerDown: ee(o.onPointerDown, () => {
      a.current === null && (a.current = window.setInterval(r, 50));
    }),
    onPointerMove: ee(o.onPointerMove, () => {
      var c;
      (c = i.onItemLeave) === null || c === void 0 || c.call(i), a.current === null && (a.current = window.setInterval(r, 50));
    }),
    onPointerLeave: ee(o.onPointerLeave, () => {
      s();
    })
  }));
}), au = /* @__PURE__ */ V((e, t) => {
  const { __scopeSelect: n, ...r } = e;
  return /* @__PURE__ */ C(ne.div, W({
    "aria-hidden": !0
  }, r, {
    ref: t
  }));
});
function Ai(e) {
  return e === "" || e === void 0;
}
const Ni = /* @__PURE__ */ V((e, t) => {
  const { value: n, ...r } = e, o = L(null), i = re(t, o), a = jc(n);
  return H(() => {
    const l = o.current, s = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(s, "value").set;
    if (a !== n && d) {
      const h = new Event("change", {
        bubbles: !0
      });
      d.call(l, n), l.dispatchEvent(h);
    }
  }, [
    a,
    n
  ]), /* @__PURE__ */ C(Xc, {
    asChild: !0
  }, /* @__PURE__ */ C("select", W({}, r, {
    ref: i,
    defaultValue: n
  })));
});
Ni.displayName = "BubbleSelect";
function Li(e) {
  const t = De(e), n = L(""), r = L(0), o = K((a) => {
    const l = n.current + a;
    t(l), function s(c) {
      n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(
        () => s(""),
        1e3
      ));
    }(l);
  }, [
    t
  ]), i = K(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return H(() => () => window.clearTimeout(r.current), []), [
    n,
    o,
    i
  ];
}
function ki(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (c) => c === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = lu(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter(
    (c) => c !== n
  ));
  const s = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return s !== n ? s : void 0;
}
function lu(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const su = Fd, Ri = _d, cu = Bd, du = Kd, uu = Wd, Fi = zd, fu = Yd, Vi = Qd, _i = eu, pu = tu, vu = ru, Hi = ou, Bi = iu, Ki = au, mu = su, hu = cu, Wi = V(({
  className: e,
  children: t,
  ...n
}, r) => S(Ri, {
  ref: r,
  className: ie("tw-typ-body-3 tw-flex tw-h-9 tw-w-full tw-items-center tw-justify-between tw-whitespace-nowrap tw-bg-transparent tw-px-3 tw-py-2 tw-ring-offset-background placeholder:tw-text-secondary focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-secondary disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>span]:tw-line-clamp-1 [&_svg]:data-[state=open]:tw-rotate-180", e),
  ...n,
  children: [t, S(du, {
    asChild: !0,
    children: S(Xn, {
      size: 14
    })
  })]
}));
Wi.displayName = Ri.displayName;
const zi = V(({
  className: e,
  ...t
}, n) => S(Hi, {
  ref: n,
  className: ie("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-1", e),
  ...t,
  children: S(xa, {})
}));
zi.displayName = Hi.displayName;
const Ui = V(({
  className: e,
  ...t
}, n) => S(Bi, {
  ref: n,
  className: ie("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-1", e),
  ...t,
  children: S(Xn, {})
}));
Ui.displayName = Bi.displayName;
const ji = V(({
  className: e,
  children: t,
  position: n = "popper",
  ...r
}, o) => S(uu, {
  children: S(Fi, {
    ref: o,
    className: ie("tw-relative tw-z-50 tw-max-h-96 tw-min-w-[8rem] tw-overflow-hidden tw-bg-background tw-text-primary tw-shadow-lg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2", n === "popper" && "data-[side=bottom]:tw-translate-y-1 data-[side=left]:tw--translate-x-1 data-[side=right]:tw-translate-x-1 data-[side=top]:tw--translate-y-1", e),
    position: n,
    ...r,
    children: [S(zi, {}), S(fu, {
      className: ie("tw-p-1", n === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-w-full tw-min-w-[var(--radix-select-trigger-width)]"),
      children: t
    }), S(Ui, {})]
  })
}));
ji.displayName = Fi.displayName;
const gu = V(({
  className: e,
  ...t
}, n) => S(Vi, {
  ref: n,
  className: ie("tw-px-2 tw-py-1.5 tw-text-sm tw-font-semibold", e),
  ...t
}));
gu.displayName = Vi.displayName;
const Xi = V(({
  className: e,
  children: t,
  ...n
}, r) => S(_i, {
  ref: r,
  className: ie("tw-typ-body-3 tw-relative tw-flex tw-w-full tw-cursor-default tw-select-none tw-items-center tw-py-1.5 tw-pl-2 tw-pr-8 tw-outline-none focus:tw-bg-box-background focus:tw-text-primary data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50", e),
  ...n,
  children: [S("span", {
    className: "tw-absolute tw-right-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center",
    children: S(vu, {
      children: S(so, {
        size: 14
      })
    })
  }), S(pu, {
    children: t
  })]
}));
Xi.displayName = _i.displayName;
const bu = V(({
  className: e,
  ...t
}, n) => S(Ki, {
  ref: n,
  className: ie("tw-bg-muted tw-mx-1 tw-my-1 tw-h-px", e),
  ...t
}));
bu.displayName = Ki.displayName;
function wu(e, t) {
  return va((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const cn = (e) => {
  const { present: t, children: n } = e, r = $u(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Re.only(n), i = re(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Yt(o, {
    ref: i
  }) : null;
};
cn.displayName = "Presence";
function $u(e) {
  const [t, n] = F(), r = L({}), o = L(e), i = L("none"), a = e ? "mounted" : "unmounted", [l, s] = wu(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return H(() => {
    const c = Nt(r.current);
    i.current = l === "mounted" ? c : "none";
  }, [
    l
  ]), ue(() => {
    const c = r.current, d = o.current;
    if (d !== e) {
      const b = i.current, u = Nt(c);
      e ? s("MOUNT") : u === "none" || (c == null ? void 0 : c.display) === "none" ? s("UNMOUNT") : s(d && b !== u ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    s
  ]), ue(() => {
    if (t) {
      const c = (h) => {
        const u = Nt(r.current).includes(h.animationName);
        h.target === t && u && jn(
          () => s("ANIMATION_END")
        );
      }, d = (h) => {
        h.target === t && (i.current = Nt(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      s("ANIMATION_END");
  }, [
    t,
    s
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(l),
    ref: K((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Nt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const Yi = "Dialog", [Gi, cf] = tn(Yi), [yu, ye] = Gi(Yi), xu = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: a = !0 } = e, l = L(null), s = L(null), [c = !1, d] = Bn({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ C(yu, {
    scope: t,
    triggerRef: l,
    contentRef: s,
    contentId: vt(),
    titleId: vt(),
    descriptionId: vt(),
    open: c,
    onOpenChange: d,
    onOpenToggle: K(
      () => d(
        (h) => !h
      ),
      [
        d
      ]
    ),
    modal: a
  }, n);
}, Pu = "DialogTrigger", Tu = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ye(Pu, n), i = re(t, o.triggerRef);
  return /* @__PURE__ */ C(ne.button, W({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": fr(o.open)
  }, r, {
    ref: i,
    onClick: ee(e.onClick, o.onOpenToggle)
  }));
}), qi = "DialogPortal", [Su, Zi] = Gi(qi, {
  forceMount: void 0
}), Eu = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = ye(qi, t);
  return /* @__PURE__ */ C(Su, {
    scope: t,
    forceMount: n
  }, Re.map(
    r,
    (a) => /* @__PURE__ */ C(cn, {
      present: n || i.open
    }, /* @__PURE__ */ C(bi, {
      asChild: !0,
      container: o
    }, a))
  ));
}, zn = "DialogOverlay", Cu = /* @__PURE__ */ V((e, t) => {
  const n = Zi(zn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ye(zn, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ C(cn, {
    present: r || i.open
  }, /* @__PURE__ */ C(Du, W({}, o, {
    ref: t
  }))) : null;
}), Du = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ye(zn, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ C(Di, {
      as: tt,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ C(ne.div, W({
      "data-state": fr(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), wt = "DialogContent", Ou = /* @__PURE__ */ V((e, t) => {
  const n = Zi(wt, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = ye(wt, e.__scopeDialog);
  return /* @__PURE__ */ C(cn, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ C(Mu, W({}, o, {
    ref: t
  })) : /* @__PURE__ */ C(Iu, W({}, o, {
    ref: t
  })));
}), Mu = /* @__PURE__ */ V((e, t) => {
  const n = ye(wt, e.__scopeDialog), r = L(null), o = re(t, n.contentRef, r);
  return H(() => {
    const i = r.current;
    if (i)
      return $i(i);
  }, []), /* @__PURE__ */ C(Qi, W({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ee(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: ee(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || l) && i.preventDefault();
    }),
    onFocusOutside: ee(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), Iu = /* @__PURE__ */ V((e, t) => {
  const n = ye(wt, e.__scopeDialog), r = L(!1), o = L(!1);
  return /* @__PURE__ */ C(Qi, W({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var l;
        r.current || (l = n.triggerRef.current) === null || l === void 0 || l.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var a, l;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const s = i.target;
      ((l = n.triggerRef.current) === null || l === void 0 ? void 0 : l.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), Qi = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, l = ye(wt, n), s = L(null), c = re(t, s);
  return Jo(), /* @__PURE__ */ C(Ae, null, /* @__PURE__ */ C(ei, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ C(Zo, W({
    role: "dialog",
    id: l.contentId,
    "aria-describedby": l.descriptionId,
    "aria-labelledby": l.titleId,
    "data-state": fr(l.open)
  }, a, {
    ref: c,
    onDismiss: () => l.onOpenChange(!1)
  }))), !1);
}), Au = "DialogTitle", Nu = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ye(Au, n);
  return /* @__PURE__ */ C(ne.h2, W({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), Lu = "DialogDescription", ku = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ye(Lu, n);
  return /* @__PURE__ */ C(ne.p, W({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), Ru = "DialogClose", Fu = /* @__PURE__ */ V((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = ye(Ru, n);
  return /* @__PURE__ */ C(ne.button, W({
    type: "button"
  }, r, {
    ref: t,
    onClick: ee(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function fr(e) {
  return e ? "open" : "closed";
}
const Vu = xu, _u = Tu, Hu = Eu, Ji = Cu, ea = Ou, ta = Nu, na = ku, Bu = Fu, Ku = Vu, Wu = _u, zu = Hu, ra = V(({
  className: e,
  ...t
}, n) => S(Ji, {
  className: ie("tw- tw-fixed tw-inset-0 tw-z-50 tw-bg-black/80 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0", e),
  ...t,
  ref: n
}));
ra.displayName = Ji.displayName;
const Uu = io({
  base: "tw-fixed tw-z-50 tw-gap-4 tw-bg-background tw-p-6 tw-shadow-lg tw-transition tw-ease-in-out data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-duration-500",
  variants: {
    side: {
      top: "tw-inset-x-0 tw-top-0 tw-border-b data-[state=closed]:tw-slide-out-to-top data-[state=open]:tw-slide-in-from-top",
      bottom: "tw-inset-x-0 tw-bottom-0 tw-border-t data-[state=closed]:tw-slide-out-to-bottom data-[state=open]:tw-slide-in-from-bottom",
      left: "tw-inset-y-0 tw-left-0 tw-h-full tw-w-3/4 tw-border-r data-[state=closed]:tw-slide-out-to-left data-[state=open]:tw-slide-in-from-left sm:tw-max-w-sm",
      right: "tw-inset-y-0 tw-right-0 tw-h-full tw-w-3/4 tw-border-l data-[state=closed]:tw-slide-out-to-right data-[state=open]:tw-slide-in-from-right sm:tw-max-w-sm"
    }
  },
  defaultVariants: {
    side: "right"
  }
}), oa = V(({
  side: e = "right",
  className: t,
  children: n,
  ...r
}, o) => S(zu, {
  children: [S(ra, {
    className: "!tw-block"
  }), S(ea, {
    ref: o,
    className: ie(Uu({
      side: e
    }), t),
    ...r,
    children: [n, S(Bu, {
      className: "focus:tw-ring-ring tw-absolute tw-right-4 tw-top-4 tw-rounded-sm tw-opacity-70 tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 disabled:tw-pointer-events-none data-[state=open]:tw-bg-secondary",
      children: [S(co, {
        size: 20
      }), S("span", {
        className: "tw-sr-only",
        children: "Close"
      })]
    })]
  })]
}));
oa.displayName = ea.displayName;
const ia = ({
  className: e,
  ...t
}) => S("div", {
  className: ie("tw-flex tw-flex-col tw-space-y-2 tw-text-center sm:tw-text-left", e),
  ...t
});
ia.displayName = "SheetHeader";
const ju = V(({
  className: e,
  ...t
}, n) => S(ta, {
  ref: n,
  className: ie("tw-text-foreground tw-text-lg tw-font-semibold", e),
  ...t
}));
ju.displayName = ta.displayName;
const Xu = V(({
  className: e,
  ...t
}, n) => S(na, {
  ref: n,
  className: ie("tw-text-muted-foreground tw-text-sm", e),
  ...t
}));
Xu.displayName = na.displayName;
function Un(e, t, n) {
  var r, o, i, a, l;
  t == null && (t = 100);
  function s() {
    var d = Date.now() - a;
    d < t && d >= 0 ? r = setTimeout(s, t - d) : (r = null, n || (l = e.apply(i, o), i = o = null));
  }
  var c = function() {
    i = this, o = arguments, a = Date.now();
    var d = n && !r;
    return r || (r = setTimeout(s, t)), d && (l = e.apply(i, o), i = o = null), l;
  };
  return c.clear = function() {
    r && (clearTimeout(r), r = null);
  }, c.flush = function() {
    r && (l = e.apply(i, o), i = o = null, clearTimeout(r), r = null);
  }, c;
}
Un.debounce = Un;
var Yu = Un;
const ro = /* @__PURE__ */ ba(Yu);
function Gu(e) {
  let {
    debounce: t,
    scroll: n,
    polyfill: r,
    offsetSize: o
  } = e === void 0 ? {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
  } : e;
  const i = r || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!i)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [a, l] = F({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }), s = L({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: a
  }), c = t ? typeof t == "number" ? t : t.scroll : null, d = t ? typeof t == "number" ? t : t.resize : null, h = L(!1);
  H(() => (h.current = !0, () => void (h.current = !1)));
  const [b, u, g] = Z(() => {
    const v = () => {
      if (!s.current.element)
        return;
      const {
        left: $,
        top: y,
        width: T,
        height: O,
        bottom: A,
        right: p,
        x: I,
        y: R
      } = s.current.element.getBoundingClientRect(), E = {
        left: $,
        top: y,
        width: T,
        height: O,
        bottom: A,
        right: p,
        x: I,
        y: R
      };
      s.current.element instanceof HTMLElement && o && (E.height = s.current.element.offsetHeight, E.width = s.current.element.offsetWidth), Object.freeze(E), h.current && !Ju(s.current.lastBounds, E) && l(s.current.lastBounds = E);
    };
    return [v, d ? ro(v, d) : v, c ? ro(v, c) : v];
  }, [l, o, c, d]);
  function f() {
    s.current.scrollContainers && (s.current.scrollContainers.forEach((v) => v.removeEventListener("scroll", g, !0)), s.current.scrollContainers = null), s.current.resizeObserver && (s.current.resizeObserver.disconnect(), s.current.resizeObserver = null);
  }
  function w() {
    s.current.element && (s.current.resizeObserver = new i(g), s.current.resizeObserver.observe(s.current.element), n && s.current.scrollContainers && s.current.scrollContainers.forEach((v) => v.addEventListener("scroll", g, {
      capture: !0,
      passive: !0
    })));
  }
  const m = (v) => {
    !v || v === s.current.element || (f(), s.current.element = v, s.current.scrollContainers = aa(v), w());
  };
  return Zu(g, !!n), qu(u), H(() => {
    f(), w();
  }, [n, g, u]), H(() => f, []), [m, a, b];
}
function qu(e) {
  H(() => {
    const t = e;
    return window.addEventListener("resize", t), () => void window.removeEventListener("resize", t);
  }, [e]);
}
function Zu(e, t) {
  H(() => {
    if (t) {
      const n = e;
      return window.addEventListener("scroll", n, {
        capture: !0,
        passive: !0
      }), () => void window.removeEventListener("scroll", n, !0);
    }
  }, [e, t]);
}
function aa(e) {
  const t = [];
  if (!e || e === document.body)
    return t;
  const {
    overflow: n,
    overflowX: r,
    overflowY: o
  } = window.getComputedStyle(e);
  return [n, r, o].some((i) => i === "auto" || i === "scroll") && t.push(e), [...t, ...aa(e.parentElement)];
}
const Qu = ["x", "y", "top", "bottom", "left", "right", "width", "height"], Ju = (e, t) => Qu.every((n) => e[n] === t[n]), ef = io({
  base: "tw-grid tw-h-max tw-gap-5",
  variants: {
    style: {
      tumi: "tw-grid-cols-2 tw-gap-5 md:tw-grid-cols-3",
      samsonite: "tw-grid-cols-2 tw-gap-5 lg:tw-grid-cols-3 xl:tw-grid-cols-4"
    }
  },
  defaultVariants: {
    style: "tumi"
  }
}), uf = oo((e) => {
  var u, g, f, w, m;
  const {
    results: t,
    facets: n,
    sorting: r,
    filters: o,
    services: i,
    pagination: a
  } = e.controller.store, l = window.searchspring.style, [s, c] = F(!0), [d, {
    bottom: h
  }] = Gu({
    scroll: !0
  });
  H(() => {
    const v = document.getElementById("shopify-section-header-samsonite") ?? document.getElementById("shopify-section-header-tumi");
    return v && d(v), () => {
      d(null);
    };
  }, []), Gt(() => {
    let v = !1;
    return setTimeout(() => {
      v || (window.comparator && window.comparator.refreshInputs && window.comparator.refreshInputs(), window.variants && window.variants.refresh && window.variants.refresh());
    }, 0), () => {
      v = !0;
    };
  }, [t]);
  const b = e.controller.context.collection;
  return S(wa, {
    controller: e.controller,
    children: [S("div", {
      style: {
        "--top": h + "px"
      },
      class: "tw-container tw-sticky tw-top-[var(--top)] tw-z-[1] tw-mx-auto tw-flex tw-justify-between tw-gap-5 tw-border-b tw-border-box-background tw-bg-background tw-px-4 tw-py-4 max-sm:tw-flex-col sm:tw-items-center sm:tw-py-5",
      children: [S("h1", {
        class: "tw-typ-h3-subtopic-1-a",
        children: (b == null ? void 0 : b.title) || `${window.searchspring.translations.searchTitle} "${(u = e.controller.store.search.query) == null ? void 0 : u.string}"`
      }), S("div", {
        class: "tw-flex tw-items-center tw-justify-between tw-gap-4 sm:tw-justify-end",
        children: [S("div", {
          children: [S("button", {
            className: "tw-typ-body-3 tw-flex tw-items-center tw-gap-2 max-md:tw-hidden",
            onClick: () => c((v) => !v),
            children: [S(pr, {
              size: 14
            }), s ? window.searchspring.translations.hideFilters : window.searchspring.translations.showFilters]
          }), S(Ku, {
            children: [S(Wu, {
              className: "tw-typ-body-3 tw-flex tw-items-center tw-gap-2 md:tw-hidden",
              children: [S(pr, {
                size: 14
              }), S("span", {
                children: window.searchspring.translations.showFilters
              })]
            }), S(oa, {
              side: "left",
              className: "sm:tw-max-w-screen tw-w-screen",
              children: [S(ia, {
                children: S("h2", {
                  class: "tw-typ-h2-subheading-b tw-text-start",
                  children: window.searchspring.translations.filters
                })
              }), S("div", {
                className: "tw-h-full tw-overflow-y-auto",
                children: S(Mr, {})
              })]
            })]
          })]
        }), S("div", {
          class: "tw-flex tw-gap-4",
          children: S(mu, {
            "aria-label": "sort values",
            defaultValue: (g = r.options.find((v) => v.default)) == null ? void 0 : g.value,
            value: (f = r.current) == null ? void 0 : f.value,
            onValueChange: (v) => {
              var $;
              return ($ = r.options.find((y) => y.value === v)) == null ? void 0 : $.url.go();
            },
            children: [S(Wi, {
              children: S("span", {
                className: "tw-flex",
                children: [window.searchspring.translations.sortBy, ": ", S(hu, {})]
              })
            }), S(ji, {
              children: r.options.map((v) => S(Xi, {
                value: v.value,
                children: v.label
              }, v.value))
            })]
          })
        })]
      })]
    }), S("div", {
      className: "tw-container tw-mx-auto !tw-flex tw-gap-3 tw-px-4 tw-py-2.5",
      children: [o.map((v) => S("a", {
        href: v.url.href,
        className: "tw-typ-small-1 tw-flex tw-items-center tw-gap-2 tw-bg-box-background tw-px-2.5 tw-py-2 tw-leading-none",
        onClick: ($) => v.url.link.onClick($),
        children: [v.value.label, " ", S(co, {
          size: 14
        })]
      })), o.length > 0 && S("a", {
        href: i.urlManager.remove("filter").remove("page").href,
        "aria-label": "Clear all",
        className: "tw-flex tw-items-center tw-underline",
        onClick: (v) => i.urlManager.remove("filter").remove("page").link.onClick(v),
        children: (m = (w = window.searchspring) == null ? void 0 : w.translations) == null ? void 0 : m.clearAll
      })]
    }), S("div", {
      class: "tw-container tw-mx-auto tw-flex tw-justify-center tw-gap-10 tw-px-2 sm:tw-px-4",
      children: [S("div", {
        class: ie("min-w-[226px] tw-flex tw-shrink-0 tw-flex-grow tw-basis-[226px] tw-overflow-hidden max-md:tw-hidden", !s && "tw-hidden"),
        children: S(Mr, {})
      }), S("div", {
        className: ef({
          style: l
        }),
        children: [t.filter((v) => v.type === "product").map((v) => {
          var $, y;
          return S("a", {
            href: (y = ($ = v.mappings) == null ? void 0 : $.core) == null ? void 0 : y.url,
            onMouseDown: (T) => {
              e.controller.track.product.click(T, v);
            },
            children: l === "samsonite" ? (
              // @ts-expect-error - Valid product
              S(ha, {
                product: v
              })
            ) : (
              // @ts-expect-error - Valid product
              S(ga, {
                product: v
              })
            )
          }, v.id);
        }), a.next && S("button", {
          className: "tw-button tw-button-secondary tw-col-span-full tw-mb-4",
          onClick: () => a.next.url.go({
            history: "replace"
          }),
          children: window.searchspring.translations.showMore
        })]
      })]
    })]
  });
});
export {
  uf as Search,
  uf as default
};
